import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/system";
import { useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import TabList from '@mui/lab/TabList';
import "./Reminder.css";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import AuthContext from "../../context/auth/AuthContext";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ICONS } from "../../constants/icons";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import CustomDialog from "../common/CustomDialog";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";

import usePermission from "../../usePermission";
import axios from "axios";
import useDialog from "../common/UseDialog";
import { InputSwitch } from "primereact/inputswitch";
import { CircularProgress } from "@mui/material";
import { Fragment } from "react";
import Loader from "../common/Loader";
import { Button as PrimeButton } from "primereact/button";

import { Tooltip } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import ReminderHistory from "./ReminderHistory";

import {
  Chip,
  Menu,
  MenuItem,
  Paper,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  InputAdornment,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { TrackNowButton } from "../ui";
import { TrackNowTextField } from "../ui";
import { TrackNowSelect } from "../ui";
import { TrackNowRadio } from "../ui";
import { TrackNowCheckbox } from "../ui";
import { TrackNowSwitchField } from "../ui";
import DataTableBase from "../common/DataTableBase";
import { tokens } from "../../theme/tokens";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { GoogleIconButton } from "../ui/GoogleIconButton";
import { useCommonDetailsContext } from "../../context/Common/common";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
;
;
//import {AddCircleIcon} from "@mui/material";
;
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));



export default function Reminder() {
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const tableHeaderColor = primaryColor;
  const filingMasterContext = React.useContext(ClientFilingMasterContext);
  const {
    fetchConfigurations,
    reminderConfig,
    updateReminderConfiguration,
    createReminderConfiguration,
  } = filingMasterContext;
  const authContext = React.useContext(AuthContext);
  const { authUser, roleType } = authContext;

  const navigate = useNavigate();
  const backToHome = () => {
    navigate("/");
  };
  const [mailButtonStyle, setMailButtonStyle] = useState({
    backgroundColor: "#e0e0e0",
    borderRadius: "15px",
  });
  const [tabValue, setTabValue] = useState(0);
  const [formValues, setFormValues] = useState({ Notifications: true });
  const [initialValues, setInitialValues] = useState({});
  const [initialFormValues, SetInitialFormValues] = useState({});
  const [selectedEmailscombained, setSelectedEmailsCombained] = useState([]);
  const [isFieldModified, setIsFieldModified] = useState(false);
  const [isCreating, setIsCreating] = useState(true);
  const [remainingChars, setRemainingChars] = useState(8000);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [configurationList, setConfigurationList] = useState([]);
  const [configurationListNew, setConfigurationListNew] = useState([]);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);
  const [notifications, setNotifications] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataTableLoading, setIsDataTableLoading] = useState(true);
  const [placeHolderList, setPlaceHolderList] = useState([]);
  const [userNameList, setUserNameList] = useState([]);
  const [userGroupList, setUserGroupList] = useState([]);
  const [userRoleList, setUserRoleList] = useState([]);
  //cc
  const [placeHolderListCc, setPlaceHolderListCc] = useState([]);
  const [userNameListCc, setUserNameListCc] = useState([]);
  const [userGroupListCc, setUserGroupListCc] = useState([]);
  const [userRoleListCc, setUserRoleListCc] = useState([]);
  const [emailTaskIdValue, setEmailTaskIdValue] = useState(null);
  const [emailTaskNameList, setEmailTaskNameList] = useState([]);
  const [isRecipientValidation, setIsRecipientValidation] = useState(false);
  const [env, setEnv] = useState("");
  const [selectedEmail, setSelectedEmail] = useState([]);

  const [isEqual, setIsEqual] = useState(true);

  useEffect(() => {
    if (formValues.Mail_Message) {
      const charsUsed = formValues.Mail_Message.length;
      setRemainingChars(8000 - charsUsed);
    }
  }, [formValues.Mail_Message]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [initialEmailCCandTo, setInitialEmailCCandTo] = useState([]);
  const [selectedPlaceHolderList, setSelectedPlaceHolderList] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState([]);
  const [selectedUserNameInput, setSelectedUserNameInput] = useState([]);
  const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  const [selectedRoleList, setSelectedRoleList] = useState([]);
  const [selectedPlaceHolderListCc, setSelectedPlaceHolderListCc] = useState(
    []
  );
  const [reminderEnabled, setReminderEnabled] = useState(false);
  const [selectedUserNameCc, setSelectedUserNameCc] = useState([]);
  const [selectedUserNameInputCc, setSelectedUserNameInputCc] = useState([]);
  const [selectedUserGroupCc, setSelectedUserGroupCc] = useState([]);
  const [selectedRoleListCc, setSelectedRoleListCc] = useState([]);
  //const [selectedReminderName, setSelectedReminderName] = useState('');

  const [emailInput, setEmailInput] = useState("");
  const [emailInputCc, setEmailInputCc] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailErrorCc, setEmailErrorCc] = useState("");

  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);

  // ─── Weekly Digest State ─────────────────────────────────────────────────
  const [wdEligibleUsers, setWdEligibleUsers] = useState([]);
  const [wdSelectedUserId, setWdSelectedUserId] = useState("");
  const [wdEmail, setWdEmail] = useState("");
  const [wdEmailEditing, setWdEmailEditing] = useState(false);
  const [wdEmailOverride, setWdEmailOverride] = useState("");
  const [wdEnabled, setWdEnabled] = useState(true);
  const [wdConfiguredList, setWdConfiguredList] = useState([]);
  const [wdEditingRowId, setWdEditingRowId] = useState(null);
  const [isWdTableLoading, setIsWdTableLoading] = useState(false);
  const [wdUserSearch, setWdUserSearch] = useState("");
  const wdSearchInputRef = React.useRef(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getWeeklyDigestEligibleUsers = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Application/GetWeeklyDigestEligibleUsers`
      );
      const data = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
          ? res.data.data
          : [];
      setWdEligibleUsers(data);
    } catch (err) {
      console.error("Error fetching Weekly Digest eligible users:", err);
    }
  };

  const getWeeklyDigestConfigs = async () => {
    setIsWdTableLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Application/GetWeeklyDigestConfigs`
      );
      const data = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
          ? res.data
          : [];
      setWdConfiguredList(data);
    } catch (err) {
      console.error("Error fetching Weekly Digest configs:", err);
    } finally {
      setIsWdTableLoading(false);
    }
  };

  useEffect(() => {
    if (tabValue === 3) {
      getWeeklyDigestEligibleUsers();
      getWeeklyDigestConfigs();
    }
  }, [tabValue]);

  // ─── Weekly Digest Handlers ──────────────────────────────────────────────
  const handleWdUserChange = (e) => {
    const userId = e.target.value;
    setWdSelectedUserId(userId);
    const user = wdEligibleUsers.find((u) => String(u.userId) === String(userId));
    if (user) {
      setWdEmail(user.loginId || "");
      setWdEmailOverride(user.loginId || "");
    } else {
      setWdEmail("");
      setWdEmailOverride("");
    }
    setWdEmailEditing(false);
  };

  const handleWdReset = () => {
    setWdSelectedUserId("");
    setWdEmail("");
    setWdEmailOverride("");
    setWdEmailEditing(false);
    setWdEnabled(true);
    setWdEditingRowId(null);
    setWdUserSearch("");
  };

  const handleWdSave = async () => {
    if (!wdSelectedUserId) return;
    const finalEmail = wdEmailEditing ? wdEmailOverride : wdEmail;
    const currentUserId = Number(authUser?.userId) || 0;

    try {
      if (wdEditingRowId) {
        // Update API
        const payload = {
          id: Number(wdEditingRowId),
          userId: Number(wdSelectedUserId) || 0,
          emailId: finalEmail,
          isEnabled: Boolean(wdEnabled),
          updateUser: currentUserId,
        };
        const res = await axios.put(
          `${API_BASE_URL}/Application/UpdateWeeklyDigestConfig`,
          payload
        );
        if (res?.data?.status === "Failure") {
          setAlertMessage(
            res.data.errorMessage || "Failed to update Weekly Filing Digest configuration."
          );
          setShowAlert(true);
        } else {
          setAlertMessage("Weekly Filing Digest configuration updated successfully.");
          setShowAlert(true);
          handleWdReset();
          getWeeklyDigestConfigs();
        }
      } else {
        // Create API
        const payload = {
          userId: Number(wdSelectedUserId) || 0,
          emailId: finalEmail,
          isEnabled: Boolean(wdEnabled),
          createUser: currentUserId,
        };
        const res = await axios.post(
          `${API_BASE_URL}/Application/CreateWeeklyDigestConfig`,
          payload
        );
        if (res?.data?.status === "Failure") {
          setAlertMessage(
            res.data.errorMessage || "Failed to create Weekly Filing Digest configuration."
          );
          setShowAlert(true);
        } else {
          setAlertMessage("Weekly Filing Digest configuration created successfully.");
          setShowAlert(true);
          handleWdReset();
          getWeeklyDigestConfigs();
        }
      }
    } catch (err) {
      console.error("Error saving Weekly Digest config:", err);
      setAlertMessage(
        err?.response?.data?.errorMessage ||
        err?.response?.data?.message ||
        "An error occurred while saving Weekly Filing Digest configuration."
      );
      setShowAlert(true);
    }
  };

  const wdPendingActionRef = React.useRef(null);

  const { AlertDialog: WdConfirmDialog, showDialog: showWdConfirmDialog } =
    useDialog({
      onSubmit: () => {
        if (wdPendingActionRef.current) {
          wdPendingActionRef.current();
          wdPendingActionRef.current = null;
        }
      },
      onClose: () => {
        wdPendingActionRef.current = null;
      },
    });

  const handleWdToggleSwitch = (e) => {
    const nextVal = Boolean(e.value ?? e.target?.value);
    if (nextVal) {
      setWdEnabled(true);
    } else {
      wdPendingActionRef.current = () => {
        setWdEnabled(false);
      };
      showWdConfirmDialog(
        "Confirmation",
        "If Weekly Filing Digest is turned OFF, system will not send weekly filing digest emails to this user. Do you want to change?",
        "confirm"
      );
    }
  };

  const updateWdRowStatus = async (row, nextEnabled) => {
    const currentUserId = Number(authUser?.userId) || 0;
    try {
      const payload = {
        id: Number(row.id),
        userId: Number(row.userId),
        emailId: row.emailId,
        isEnabled: Boolean(nextEnabled),
        updateUser: currentUserId,
      };
      const res = await axios.put(
        `${API_BASE_URL}/Application/UpdateWeeklyDigestConfig`,
        payload
      );
      if (res?.data?.status === "Failure") {
        setAlertMessage(res.data.errorMessage || "Failed to update status.");
        setShowAlert(true);
      } else {
        setAlertMessage(
          nextEnabled
            ? "Weekly Filing Digest turned on successfully."
            : "Weekly Filing Digest turned off successfully."
        );
        setShowAlert(true);
        getWeeklyDigestConfigs();
      }
    } catch (err) {
      console.error("Error updating Weekly Digest status:", err);
      setAlertMessage("An error occurred while updating Weekly Filing Digest status.");
      setShowAlert(true);
    }
  };

  const handleWdToggleRow = (row) => {
    if (row.isEnabled) {
      wdPendingActionRef.current = () => {
        updateWdRowStatus(row, false);
      };
      showWdConfirmDialog(
        "Confirmation",
        "If Weekly Filing Digest is turned OFF, system will not send weekly filing digest emails to this user. Do you want to change?",
        "confirm"
      );
    } else {
      updateWdRowStatus(row, true);
    }
  };

  const handleWdDeleteRow = (row) => {
    const currentUserId = Number(authUser?.userId) || 0;
    wdPendingActionRef.current = async () => {
      try {
        const res = await axios.delete(
          `${API_BASE_URL}/Application/DeleteWeeklyDigestConfig/${row.id}?updateUser=${currentUserId}`
        );
        if (res?.data?.status === "Failure") {
          setAlertMessage(
            res.data.errorMessage || "Failed to delete Weekly Filing Digest configuration."
          );
          setShowAlert(true);
        } else {
          setAlertMessage("Weekly Filing Digest configuration deleted successfully.");
          setShowAlert(true);
          getWeeklyDigestConfigs();
          if (wdEditingRowId === row.id) {
            handleWdReset();
          }
        }
      } catch (err) {
        console.error("Error deleting Weekly Digest config:", err);
        setAlertMessage("An error occurred while deleting Weekly Filing Digest configuration.");
        setShowAlert(true);
      }
    };
    showWdConfirmDialog(
      "Confirmation",
      `Are you sure you want to delete Weekly Filing Digest configuration for ${row.userName || "this user"}?`,
      "confirm"
    );
  };

  const handleWdEditRow = (row) => {
    setWdSelectedUserId(row.userId);
    setWdEmail(row.emailId || "");
    setWdEmailOverride(row.emailId || "");
    setWdEnabled(Boolean(row.isEnabled));
    setWdEmailEditing(false);
    setWdEditingRowId(row.id);
    setWdUserSearch("");
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOpenMenuCc = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleCloseMenuCc = () => {
    setAnchorE2(null);
  };
  // const handleReminderName = (event) => {
  //   setSelectedReminderName(event.target.value)

  // };
  // console.log("selectedReminderName", selectedReminderName);
  const handleSelectPlaceHolderList = (value) => {
    setIsRecipientValidation(false);
    // console.log("Value#", value);
    if (!selectedPlaceHolderList.includes(value)) {
      setSelectedPlaceHolderList([...selectedPlaceHolderList, value]);
      setSelectedEmailsCombained([...selectedEmailscombained, value]);
    }
  };
  const handleSelectPlaceHolderListCc = (value) => {
    // console.log("Value#", value);
    if (!selectedPlaceHolderListCc.includes(value)) {
      setSelectedPlaceHolderListCc([...selectedPlaceHolderListCc, value]);
      setSelectedEmailsCombained([...selectedEmailscombained, value]);
    }
  };

  const handleSelectRoleName = (value) => {
    setIsRecipientValidation(false);
    if (!selectedRoleList.includes(value)) {
      setSelectedRoleList([...selectedRoleList, value]);
      setSelectedEmailsCombained([...selectedEmailscombained, value]);
    }
  };
  const handleSelectRoleNameCc = (value) => {
    if (!selectedRoleListCc.includes(value)) {
      setSelectedRoleListCc([...selectedRoleListCc, value]);
      setSelectedEmailsCombained([...selectedEmailscombained, value]);
    }
  };

  const handleSelectedValueUserName = (user) => {
    setIsRecipientValidation(false);
    if (
      !selectedUserName.some(
        (selectedUser) => selectedUser.userEmailId === user.userEmailId
      )
    ) {
      const selectedUser = {
        userEmailId: user.userEmailId,
        placeHolderName: user.placeHolderName,
      };
      setSelectedUserName([...selectedUserName, selectedUser]);
      setSelectedEmailsCombained([...selectedEmailscombained, selectedUser]);
    }
  };

  const handleSelectedValueUserNameCc = (user) => {
    if (
      !selectedUserNameCc.some(
        (selectedUser) => selectedUser.userEmailId === user.userEmailId
      )
    ) {
      const selectedUser = {
        userEmailId: user.userEmailId,
        placeHolderName: user.placeHolderName,
      };
      setSelectedUserNameCc([...selectedUserNameCc, selectedUser]);
      setSelectedEmailsCombained([...selectedEmailscombained, selectedUser]);
    }
  };
  const handleGroupList = (value) => {
    setIsRecipientValidation(false);
    if (!selectedUserGroup.includes(value)) {
      setSelectedUserGroup([...selectedUserGroup, value]);
    }
  };
  const handleGroupListCc = (value) => {
    if (!selectedUserGroupCc.includes(value)) {
      setSelectedUserGroupCc([...selectedUserGroupCc, value]);
    }
  };
  const handleEmailInputChange = (event) => {
    const { value } = event.target;
    setEmailInput(value);
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (value && !emailRegex.test(value)) {
      setEmailError("Invalid email address");
    } else {
      setEmailError("");
    }
  };
  const handleEmailInputChangeCc = (event) => {
    const { value } = event.target;
    setEmailInputCc(value);
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (value && !emailRegex.test(value)) {
      setEmailErrorCc("Invalid email address");
    } else {
      setEmailErrorCc("");
    }
  };
  // const handleAddEmailChip = () => {
  //   if (emailInput.trim() !== "" && !selectedUserName.includes(emailInput)) {
  //     setSelectedUserName([...selectedUserName, emailInput]);
  //     setEmailInput("");
  //   }
  // };
  const handleAddEmailChip = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (emailInput.trim() !== "") {
      setIsRecipientValidation(false);
      if (emailRegex.test(emailInput)) {
        if (!selectedUserNameInput.includes(emailInput)) {
          // setSelectedUserName([...selectedUserName, emailInput]);
          setSelectedUserNameInput([...selectedUserNameInput, emailInput]);
          setSelectedEmailsCombained([...selectedEmailscombained, emailInput]);
          setEmailInput("");
        } else {
          setEmailError("Email already in the list");
        }
      } else {
        setEmailError("Invalid email address");
      }
    }
  };
  const handleAddEmailChipCc = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (emailInputCc.trim() !== "") {
      if (emailRegex.test(emailInputCc)) {
        if (!selectedUserNameInputCc.includes(emailInputCc)) {
          //  setSelectedUserNameCc([...selectedUserNameCc, emailInputCc]);
          setSelectedUserNameInputCc([
            ...selectedUserNameInputCc,
            emailInputCc,
          ]);
          setSelectedEmailsCombained([
            ...selectedEmailscombained,
            emailInputCc,
          ]);
          setEmailInputCc("");
        } else {
          setEmailErrorCc("Email already in the list");
        }
      } else {
        setEmailErrorCc("Invalid email address");
      }
    }
  };
  const handleRemoveValue = (value) => {
    setSelectedUserName(selectedUserName.filter((item) => item !== value));
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveValueInput = (value) => {
    setSelectedUserNameInput(
      selectedUserNameInput.filter((item) => item !== value)
    );
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveUserGroup = (value) => {
    setSelectedUserGroup(selectedUserGroup.filter((item) => item !== value));
  };
  const handleRemoveValuePlace = (value) => {
    setSelectedPlaceHolderList(
      selectedPlaceHolderList.filter((item) => item !== value)
    );
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveValueRoles = (value) => {
    setSelectedRoleList(selectedRoleList.filter((item) => item !== value));
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveUserGroupCc = (value) => {
    setSelectedUserGroupCc(
      selectedUserGroupCc.filter((item) => item !== value)
    );
  };
  const handleRemoveValuePlaceCc = (value) => {
    setSelectedPlaceHolderListCc(
      selectedPlaceHolderListCc.filter((item) => item !== value)
    );
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveValueRolesCc = (value) => {
    setSelectedRoleListCc(selectedRoleListCc.filter((item) => item !== value));
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveValueCc = (value) => {
    setSelectedUserNameCc(selectedUserNameCc.filter((item) => item !== value));
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };
  const handleRemoveValueInputCc = (value) => {
    setSelectedUserNameInputCc(
      selectedUserNameInputCc.filter((item) => item !== value)
    );
    setSelectedEmailsCombained(
      selectedEmailscombained.filter((item) => item !== value)
    );
  };

  //   console.log("selectedValEmail##", selectedUserName);
  //   console.log("selectedUserGroup##", selectedUserGroup);
  //   console.log("selectedPlaceHolderList##", selectedPlaceHolderList);
  //   console.log("selectedRoleList##", selectedRoleList);
  //   console.log("CC-selectedValEmail##", selectedUserNameCc);
  //   console.log("CC-selectedUserGroup##", selectedUserGroupCc);
  //   console.log("CC-selectedPlaceHolderList##", selectedPlaceHolderListCc);
  //   console.log("CC-selectedRoleList##", selectedRoleListCc);
  // useEffect(async () => {

  //   const res = await axios.get(`${API_BASE_URL}/Application/ListEmails`);

  //   if (res) {
  //     setPlaceHolders(res.data.emailTaskName);

  //   }

  // }, []);

  const recordtypes = ["TrackNow", "PostAward"];

  const getPlaceHolders = async () => {
    try {
      let resData = await axios.get(
        `${API_BASE_URL}/Application/ListEmailMasterPlaceHolderNameValues`
      );
      let placeHolder = [
        {
          placeHolderId: 12,
          placeHolderName: "{{StaffAssigned}}",
          replaceValueField: "UserID",
          replaceValueTable: "CustomerFilingTrackerStaffAssigned",
          replaceValueDB: null,
          isUsername: false,
          isGroupName: false,
          isRoleName: false,
          isReplacerName: true,
          createDate: "2023-08-28T14:53:51.52",
          createUser: "1",
          updateDate: null,
          updateUser: null,
        },
        {
          placeHolderId: 15,
          placeHolderName: "{{ClientFilingApprover}}",
          replaceValueField: "CurrentApproverID",
          replaceValueTable: "CustomerFilingMasterWorkflow",
          replaceValueDB: null,
          isUsername: false,
          isGroupName: false,
          isRoleName: false,
          isReplacerName: true,
          createDate: "2023-08-30T05:57:10.89",
          createUser: "1",
          updateDate: null,
          updateUser: null,
        },
        {
          placeHolderId: 16,
          placeHolderName: "{{ClientFilingRequester}}",
          replaceValueField: "WorkflowInitiatorId",
          replaceValueTable: "CustomerFilingMasterWorkflow",
          replaceValueDB: null,
          isUsername: false,
          isGroupName: false,
          isRoleName: false,
          isReplacerName: true,
          createDate: "2023-08-30T05:57:10.89",
          createUser: "1",
          updateDate: null,
          updateUser: null,
        },
        {
          placeHolderId: 17,
          placeHolderName: "{{FilingApprover}}",
          replaceValueField: "CurrentApproverID",
          replaceValueTable: "FilingMasterWorkflow",
          replaceValueDB: null,
          isUsername: false,
          isGroupName: false,
          isRoleName: false,
          isReplacerName: true,
          createDate: "2023-08-30T05:57:10.89",
          createUser: "1",
          updateDate: null,
          updateUser: null,
        },
        {
          placeHolderId: 18,
          placeHolderName: "{{FilingRequester}}",
          replaceValueField: "WorkflowInitiatorId",
          replaceValueTable: "FilingMasterWorkflow",
          replaceValueDB: null,
          isUsername: false,
          isGroupName: false,
          isRoleName: false,
          isReplacerName: true,
          createDate: "2023-08-30T05:57:10.89",
          createUser: "1",
          updateDate: null,
          updateUser: null,
        },
      ];
      let userGroup = resData.data.data.filter(
        (item) =>
          item.isReplacerName === false &&
          item.isGroupName === true &&
          item.isUsername === false &&
          item.isRoleName === false
      );
      let userName = resData.data.data.filter(
        (item) =>
          item.isReplacerName === false &&
          item.isGroupName === false &&
          item.isUsername === true &&
          item.isRoleName === false
      );
      let roleList = resData.data.data.filter(
        (item) =>
          item.isReplacerName === false &&
          item.isGroupName === false &&
          item.isUsername === false &&
          item.isRoleName === true
      );
      try {
        if (formValues.Client) {


          let updUserName = userName.filter((user) => {
            return (
              user &&
              user.roleName &&
              (user.roleName === "JSISME" ||
                user.roleName === "Admin" ||
                user.roleName === "JSISME-PostAward" ||
                user.roleName === "Admin-PostAward") &&
              user.customerID === null
            );
          });
          let filtCust = userName.filter(
            (cust) => cust.customerID === formValues.Client.code
          );
          const updUserList = [...updUserName, ...filtCust];
          const uniquePlaceHolderIds = new Set();
          userName = updUserList.filter((user) => {
            if (!uniquePlaceHolderIds.has(user.placeHolderId)) {
              uniquePlaceHolderIds.add(user.placeHolderId);
              return true;
            }
            return false;
          });

        } else {

          let updUserName = userName.filter((user) => {
            return (
              user &&
              user.roleName &&
              (user.roleName === "JSISME" ||
                user.roleName === "Admin" ||
                user.roleName === "JSISME-PostAward" ||
                user.roleName === "Admin-PostAward") &&
              user.customerID === null
            );
          });
          // userName = updUserName;
          const uniquePlaceHolderIds = new Set();
          userName = updUserName.filter((user) => {
            if (!uniquePlaceHolderIds.has(user.placeHolderId)) {
              uniquePlaceHolderIds.add(user.placeHolderId);
              return true;
            }
            return false;
          });
        }
      } catch (error) {
      }
      setUserNameList(userName);
      setPlaceHolderList(placeHolder);
      setUserGroupList(userGroup);
      setUserRoleList(roleList);
      setPlaceHolderListCc(placeHolder);
      setUserGroupListCc(userGroup);
      setUserNameListCc(userName);
      setUserRoleListCc(roleList);

    } catch (error) {
      console.log("FETCHERROR#", error);
    }
  };

  useEffect(() => {
    getPlaceHolders();
    if (!formValues.Client) return;

    let message = "";
    let subject = "";

    // Past Due Tab
    if (tabValue === 1) {
      message = `A filing is past due from your clients reporting list! Please review the updated list to stay informed of the current reporting requirements.<br/><br/>
<b>Filing Name :</b> {{FMFilingName}}<br/>
<b>Due Date :</b> {{FilingDueDate}}<br/>
<b>Client Name :</b> {{CustomerName}}<br/>
<b>Jurisdiction :</b> {{FMJurisdiction}}<br/>
<b>State :</b> {{FMState}}<br/>
<b>Filing Frequency :</b> {{FMFilingFrequency}}<br/>
<b>Notes :</b> {{FMNotes}}<br/>
<b>Rule Reference :</b> {{FMRule Reference}}<br/>
<b>Who Must File (Federal/State) :</b> {{FilingBusinessCategory}}<br/>`;
      subject = `Filing is past due from Your Client's TrackNow Reporting List- Form Type: {{FMFilingName}} | Company Name: {{CustomerName}}`
    }

    // Completed Tab
    if (tabValue === 2) {
      message = `A filing has been <b>SUBMITTED</b> from your clients reporting list! Please review the updated list to stay informed of the current reporting requirements.<br/><br/>
<b>Filing Name :</b> {{FMFilingName}}<br/>
<b>Due Date :</b> {{FilingDueDate}}<br/>
<b>Client Name :</b> {{CustomerName}}<br/>
<b>Jurisdiction :</b> {{FMJurisdiction}}<br/>
<b>State :</b> {{FMState}}<br/>
<b>Filing Frequency :</b> {{FMFilingFrequency}}<br/>
<b>Notes :</b> {{FMNotes}}<br/>
<b>Rule Reference :</b> {{FMRule Reference}}<br/>
<b>Who Must File (Federal/State) :</b> {{FilingBusinessCategory}}<br/>`;
      subject = `Filing Submitted from Your Client's TrackNow Reporting List- Form Type: {{FMFilingName}} | Company Name: {{CustomerName}}`
    }

    // Only update for tab 1 & 2
    if (tabValue === 1 || tabValue === 2) {
      setFormValues((prev) => ({
        ...prev,
        Mail_Message: message,
        Mail_Subject: subject
      }));
    }

  }, [formValues.Client, tabValue]);

  // useEffect(() => {
  //   console.log("InitialValues", initialValues, "formValues", formValues);

  //   // Check each key in formValues
  //   for (let key in formValues) {
  //     if (initialValues[key] !== formValues[key]) {
  //       setIsEqual(false)
  //       break;
  //     }
  //   }
  // }, [formValues]);

  useEffect(() => {
    if (!emailTaskIdValue) {

      const filteredSelectedUserName = selectedUserName.filter((userName) => {
        const isEmailFormat = /\S+@\S+\.\S+/.test(userName.placeHolderName);
        const isNameInList = userNameList.some(
          (user) => user.placeHolderName === userName.placeHolderName
        );
        return isEmailFormat || isNameInList;
      });

      setSelectedUserName(filteredSelectedUserName);
      setSelectedEmailsCombained(filteredSelectedUserName);

      const filteredSelectedUserNameCc = selectedUserNameCc.filter(
        (userName) => {
          const isEmailFormat = /\S+@\S+\.\S+/.test(userName.placeHolderName);
          const isNameInList = userNameListCc.some(
            (user) => user.placeHolderName === userName.placeHolderName
          );
          return isEmailFormat || isNameInList;
        }
      );
      setSelectedUserNameCc(filteredSelectedUserNameCc);
      setSelectedEmailsCombained(filteredSelectedUserNameCc);


    }
  }, [formValues.Client, userNameList]);

  const MailFields = [
    "Mail_Subject",
    "Mail_Message",
    "Mail_ReminderBefore",
    "Mail_ReminderFrequency",
  ];
  const SMSFields = [
    "SMS_Subject",
    "SMS_Message",
    "SMS_ReminderBefore",
    "SMS_ReminderFrequency",
  ];

  const initMailForm = {
    Mail_Subject: "",
    Mail_Message: "",
    Mail_ReminderBefore: "",
    Mail_ReminderFrequency: "",
  };

  const envUrls = {
    Uat: "https://jsi-tracknow-cert.azurewebsites.net/",
    Qa: "https://jsi-tracknow-test.azurewebsites.net/",
    Dev: "https://jsi-tracknow-dev.azurewebsites.net/",
    Prod: "https://tracknow.jsiportal.com/",

  };
  const getEnvConfigs = async () => {
    try {
      const envRes = await axios.get(
        `${API_BASE_URL}/Application/ListappconfigurationEnvironment`
      );
      const envValue = envRes.data.data[0].environment;
      setEnv(envValue);
    } catch (error) {
      console.error("EnvError", error);
    }
  };
  const getConfigs = async () => {
    try {
      let res;
      if (tabValue == 1) {
        res = await axios.get(`${API_BASE_URL}/Application/ListPastDueEmails`);
      } else if (tabValue == 2) {
        res = await axios.get(`${API_BASE_URL}/Application/ListCompletedEmails`);
      } else {
        res = await axios.get(`${API_BASE_URL}/Application/ListEmails`);
      }

      const filteredReminder = (tabValue == 1 || tabValue == 2) ? res.data.data : res.data.data.filter(
        (item) => item.isReminder === true
      );
      const resEmailTaskName = filteredReminder.map(
        (item) => item.emailTaskName
      );
      setEmailTaskNameList(resEmailTaskName);
      SetInitialFormValues(filteredReminder);
      setConfigurationListNew(filteredReminder);
    } catch (error) {
      console.log(error);
    } finally {
      setIsDataTableLoading(false);
    }
  };

  const cellNotifications = (row) => {
    return <InputSwitch name="Notifications" checked={row.isActive} />;
  };
  const removeNegative = (row) => {
    const removedNegative =
      row.reminderStartInDays < 0
        ? Math.abs(row.reminderStartInDays)
        : row.reminderStartInDays;
    return removedNegative;
  };
  const dueDateFormat = (row) => {
    const dueDateFormated =
      row.reminderBasedOnField === ("FilingDueDate" || "Filing")
        ? "Filing"
        : row.reminderBasedOnField === ("DueDate" || "Internal")
          ? "Internal"
          : "Both";
    return dueDateFormated;
  };
  const cellMessage = (row) => {
    const emailMessageWithoutLinks = row.emailMessage
      .replace(/<a\b[^>]*>(.*?)<\/a>/g, "")
      .replace(/Please click on this link to Login:/g, "")
      .replace(/<hr\/?>/g, "")
      .replace(/<br\/?>/g, "");
    return (
      <div
        name="Notifications"
        dangerouslySetInnerHTML={{ __html: emailMessageWithoutLinks }}
      />
    );
  };

  const getCustomerList = async () => {
    try {
      let res = await axios.get(`${API_BASE_URL}/Customer/CustomerList`);
      let _data;
      if (
        !(roleType?.includes("Admin") || roleType?.includes("Admin-PostAward"))
      ) {
        _data = res.data
          .filter((ele) => authUser.clients.includes(ele.customerId))
          .map((ele) => ({
            code: ele.customerId,
            name: ele.customerName,
          }));
      } else {
        _data = res.data.map((ele) => ({
          code: ele.customerId,
          name: ele.customerName,
        }));
      }
      setCustomerList(_data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // getConfigs();
    getCustomerList();
  }, []);

  useEffect(() => {
    getEnvConfigs();
  }, []);

  useEffect(() => {
    if (customerList.length > 0) {
      getConfigs();
      handleReset()
    }
  }, [customerList, tabValue]);

  useEffect(() => {
    // if (formValues.RecordType === "PostAward") {
    //   setFormValues((prevValues) => ({
    //     ...prevValues,
    //     Due_Date_Type: "Internal",
    //   }));
    // }
    // else {
    //   setFormValues((prevValues) => ({
    //     ...prevValues,
    //     Due_Date_Type: "Filing",
    //   }));
    // }
  }, [formValues.RecordType]);

  useEffect(() => {
    if (
      initialValues?.Client?.code !== formValues?.Client?.code ||
      initialValues?.Mail_Subject !== formValues?.Mail_Subject ||
      initialValues?.Mail_ReminderBefore?.toString() !==
      formValues.Mail_ReminderBefore?.toString() ||
      initialValues?.RecordType !== formValues?.RecordType ||
      initialValues?.Mail_Message !== formValues?.Mail_Message ||
      initialValues?.Due_Date_Type !== formValues?.Due_Date_Type ||
      initialValues?.Notifications !== formValues?.Notifications
    ) {
      setIsFieldModified(true);
    }
  }, [formValues]);



  const handleReset = () => {
    setFormValues({
      Mail_Message: "",
      Mail_Subject: "",
      Mail_ReminderBefore: "",
      Notifications: true,
    });
    setIsCreating(true);
    setSelectedPlaceHolderList([]);
    setSelectedUserGroup([]);
    setSelectedUserName([]);
    setSelectedUserNameInput([]);
    setSelectedEmailsCombained([]);
    setSelectedRoleList([]);
    setSelectedPlaceHolderListCc([]);
    setSelectedUserGroupCc([]);
    setSelectedUserNameCc([]);
    setSelectedUserNameInputCc([]);
    setSelectedRoleListCc([]);
    setSelectedEmail([])
    setRemainingChars(8000);
    //setSelectedReminderName('')
  };

  const handleConfigItemChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleConfigItemChanges = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const changeNotifications = () => {
    if (notifications === "on" || notifications === "off") {
      handleReminderAPI()
    } else {
      handleConfigItemChange(notifications);

    }
  };

  const handleReminderAPI = async () => {
    try {

      const emailTaskIds = selectedEmail.filter((email) => notifications === "on" ? !email.isActive : email.isActive).map((id) => id.emailTaskId)

      const payload = {
        emailTaskIds: emailTaskIds,
        isActive: notifications === "on" ? true : false,
        updateUser: authUser.userId + ""
      }
      console.log("handleReminderAPI() Payload", payload);
      const res = await axios.put(`${API_BASE_URL}/Application/BulkUpdateReminders`, payload);
      console.log("handleReminderAPI() res", res);

      if (res.data.status === "Failure") {

      } else {
        setAlertMessage(
          notifications === "on"
            ? "Reminders have been successfully turned on."
            : "Reminders have been successfully turned off."
        );
        setShowAlert(true);
      }

    } catch (err) {
      console.error(err)
    } finally {
      getConfigs();
      handleReset();
    }
  }

  const { AlertDialog: NotificationsDialog, showDialog: notificationsDialog } =
    useDialog({
      onSubmit: changeNotifications
    });

  const handleNotificationChange = (e) => {
    if (e.target.value) {
      handleConfigItemChange(e);
    } else {
      setNotifications(e);
      notificationsDialog(
        "Confirmation",
        "If Reminders is turned OFF, system will not send reminders  to the Client users. Do you want to change?",
        "confirm"
      );
    }
  };

  const createReminder = async (threeDigitReminder, paragraphMsg) => {
    let form = {};
    form[`Mail_CustomerFileTracker_Reminder_Message_${threeDigitReminder}`] =
      paragraphMsg;
    form[`Mail_CustomerFileTracker_Reminder_Subject_${threeDigitReminder}`] =
      formValues.Mail_Subject;
    form["Mail_CustomerFileTracker_Reminder_days"] =
      formValues.Mail_ReminderBefore + "";
    form[
      `Mail_CustomerFileTracker_Reminder_DueDateOption_${threeDigitReminder}`
    ] = formValues.Due_Date_Type;
    if (formValues.Notifications !== undefined) {
      let val = formValues.Notifications ? "1" : "0";
      form[`SendMail_${threeDigitReminder}`] = val;
      form[`SendNotification_${threeDigitReminder}`] = val;
    }
    let data = Object.keys(form).map((item) => {
      return {
        configItem: item,
        configItemValue: form[item],
        configId: 0,
        customerId: formValues.Client ? formValues.Client.code : null,
        createDate: new Date(Date.now()).toISOString(),
        createUser: authUser.userId + "",
      };
    });

    let res = await createReminderConfiguration(data);
    console.log("res", res);
    return res;
  };

  const handlePayLoad = async (emailTaskId) => {
    console.log(
      "authUser",
      authUser,
      "authUser.userId",
      authUser.userId,
      "createUser",
      authUser.userId + ""
    );
    let userNameCc = selectedUserNameCc.filter(
      (userCc) =>
        !selectedUserName.some(
          (user) => user.userEmailId === userCc.userEmailId
        )
    );
    let userNameInputCc = selectedUserNameInputCc.filter(
      (user) => !selectedUserNameInput.includes(user)
    );
    let userGroupCc = selectedUserGroupCc.filter(
      (user) => !selectedUserGroup.includes(user)
    );
    let roleListCc = selectedRoleListCc.filter(
      (user) => !selectedRoleList.includes(user)
    );
    let placeHoldolderCc = selectedPlaceHolderListCc.filter(
      (user) => !selectedPlaceHolderList.includes(user)
    );
    console.log("userNameCc", userNameCc);
    console.log("userNameInputCc", userNameInputCc);
    console.log("userGroupCc", userGroupCc);
    console.log("roleListCc", roleListCc);
    console.log("placeHoldolderCc", placeHoldolderCc);
    let payLoads = [];
    if (selectedUserName) {
      payLoads.push(
        ...selectedUserName.map((user) => {
          const isCC = selectedUserNameCc.some(
            (userCc) => userCc.userEmailId === user.userEmailId
          );
          return {
            emailTaskId: emailTaskId,
            userName: user.userEmailId,
            userCategory: "Users",
            emailTo: true,
            emailCC: isCC ? true : false,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selectedUserNameInput) {
      payLoads.push(
        ...selectedUserNameInput.map((user) => {
          const isCC = selectedUserNameInputCc.includes(user);
          return {
            emailTaskId: emailTaskId,
            userName: user,
            //userCategory: "",
            emailTo: true,
            emailCC: isCC ? true : false,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selectedUserGroup) {
      payLoads.push(
        ...selectedUserGroup.map((group) => {
          const isCC = selectedUserGroupCc.includes(group);
          return {
            emailTaskId: emailTaskId,
            userName: group,
            userCategory: "Groups",
            emailTo: true,
            emailCC: isCC ? true : false,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selectedRoleList) {
      payLoads.push(
        ...selectedRoleList.map((role) => {
          const isCc = selectedRoleListCc.includes(role);
          return {
            emailTaskId: emailTaskId,
            userName: role,
            userCategory: "Roles",
            emailTo: true,
            emailCC: isCc ? true : false,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selectedPlaceHolderList) {
      payLoads.push(
        ...selectedPlaceHolderList.map((role) => {
          const isCc = selectedPlaceHolderListCc.includes(role);
          return {
            emailTaskId: emailTaskId,
            userName: role,
            userCategory: "PlaceHolder",
            emailTo: true,
            emailCC: isCc ? true : false,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (userNameCc) {
      payLoads.push(
        ...userNameCc.map((user) => {
          return {
            emailTaskId: emailTaskId,
            userName: user.userEmailId,
            userCategory: "Users",
            emailTo: false,
            emailCC: true,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
            // Set emailCC based on isCC
          };
        })
      );
    }
    if (userNameInputCc) {
      payLoads.push(
        ...userNameInputCc.map((user) => {
          return {
            emailTaskId: emailTaskId,
            userName: user,
            //userCategory: "",
            emailTo: false,
            emailCC: true,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
            // Set emailCC based on isCC
          };
        })
      );
    }
    if (userGroupCc) {
      payLoads.push(
        ...userGroupCc.map((group) => {
          return {
            emailTaskId: emailTaskId,
            userName: group,
            userCategory: "Groups",
            emailTo: false,
            emailCC: true,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (roleListCc) {
      payLoads.push(
        ...roleListCc.map((role) => {
          return {
            emailTaskId: emailTaskId,
            userName: role,
            userCategory: "Roles",
            emailTo: false,
            emailCC: true,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (placeHoldolderCc) {
      payLoads.push(
        ...placeHoldolderCc.map((role) => {
          return {
            emailTaskId: emailTaskId,
            userName: role,
            userCategory: "PlaceHolder",
            emailTo: false,
            emailCC: true,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }

    console.log("PayLoad##", payLoads);
    return payLoads;
  };
  const updateRecipient = async () => {
    // createDate: new Date(Date.now()).toISOString(),
    //   createUser: authUser.userId + "",
    console.log(
      "authUser",
      authUser,
      "authUser.userId",
      authUser.userId,
      "createUser",
      authUser.userId + ""
    );

    let res = await axios.get(`${API_BASE_URL}/Application/ListEmailUsers`);
    let viewEmailUserList = res.data.data;
    let filteredEmailUserList = viewEmailUserList.filter(
      (email) => email.emailTaskId === emailTaskIdValue.emailTaskId
    );
    console.log("filteredEmailUserList", filteredEmailUserList);
    let userNameList = filteredEmailUserList.filter(
      (cat) => cat.userCategory === "Users"
    );
    let userNameListInput = filteredEmailUserList.filter(
      (cat) => cat.userCategory === null
    );
    //  let userName = userNameList.map(user => user.userName);
    let userGroupList = filteredEmailUserList.filter(
      (cat) => cat.userCategory === "Groups"
    );
    //  let userGroup = userNameList.map(user => user.userName);

    let userRolesList = filteredEmailUserList.filter(
      (cat) => cat.userCategory === "Roles"
    );
    // let userRoles = userNameList.map(user => user.userName);

    let placeHolderList = filteredEmailUserList.filter(
      (cat) => cat.userCategory === "PlaceHolder"
    );
    //  let placeHolder = userNameList.map(user => user.userName);
    const delPayLoad = [];
    const delUser = userNameList.filter((user) => {
      // Check if the userEmailId is not in selectedUserName or selectedUserNameCc
      return (
        !selectedUserName.some(
          (selectedUser) => selectedUser.userEmailId === user.userName
        ) &&
        !selectedUserNameCc.some(
          (selectedUser) => selectedUser.userEmailId === user.userName
        )
      );
    });
    const delIds = delUser.map((item) => item.id);
    delPayLoad.push(...delIds);
    console.log(
      "userNameList",
      userNameList,
      "delUser",
      delUser,
      "delPayLoad",
      delPayLoad
    );
    const delUserInput = userNameListInput.filter(
      (user) =>
        !selectedUserNameInput.includes(user.userName) &&
        !selectedUserNameInputCc.includes(user.userName)
    );
    const delInputIds = delUserInput.map((item) => item.id);
    delPayLoad.push(...delInputIds);
    const delUserGroup = userGroupList.filter(
      (user) =>
        !selectedUserGroup.includes(user.userName) &&
        !selectedUserGroupCc.includes(user.userName)
    );
    const delUserGroupIds = delUserGroup.map((item) => item.id);
    delPayLoad.push(...delUserGroupIds);

    const delPlaceHolder = placeHolderList.filter(
      (user) =>
        !selectedPlaceHolderList.includes(user.userName) &&
        !selectedPlaceHolderListCc.includes(user.userName)
    );
    const delPlaceIds = delPlaceHolder.map((item) => item.id);
    delPayLoad.push(...delPlaceIds);

    const delRole = userRolesList.filter(
      (user) =>
        !selectedRoleList.includes(user.userName) &&
        !selectedRoleListCc.includes(user.userName)
    );
    const delRoleIds = delRole.map((item) => item.id);
    delPayLoad.push(...delRoleIds);

    // let userNameCc = selectedUserNameCc.filter(
    //   (user) => !selectedUserName.includes(user)
    // );
    let userNameCc = selectedUserNameCc.filter((userCc) => {
      return !selectedUserName.some(
        (user) => user.userEmailId === userCc.userEmailId
      );
    });

    let userNameInputCc = selectedUserNameInputCc.filter(
      (user) => !selectedUserNameInput.includes(user)
    );
    let userGroupCc = selectedUserGroupCc.filter(
      (user) => !selectedUserGroup.includes(user)
    );
    let roleListCc = selectedRoleListCc.filter(
      (user) => !selectedRoleList.includes(user)
    );
    let placeHoldolderCc = selectedPlaceHolderListCc.filter(
      (user) => !selectedPlaceHolderList.includes(user)
    );
    console.log("userNameCc", userNameCc);
    console.log("userNameInputCc", userNameInputCc);
    console.log("userGroupCc", userGroupCc);
    console.log("roleListCc", roleListCc);
    console.log("placeHoldolderCc", placeHoldolderCc);
    let updatePayLoads = [];
    // const userNameCcObj = userNameCc.map((name) => {
    //   const user = userNameList.find((user) => user.userName === name.userEmailId);
    //   return user
    //     ? { id: user.id, userName: user.userName }
    //     : { id: 0, userName: name.userEmailId };
    // });
    // const selUserNameobj = selectedUserName.map((name) => {
    //   const user = userNameList.find((user) => user.userName === name);
    //   return user ? { id: user.id, userName: user.userName } : { id: 0, userName: name };
    // });
    // const selUserNameCcobj = selectedUserNameCc.map((name) => {
    //   const user = userNameList.find((user) => user.userName === name);
    //   return user ? { id: user.id, userName: user.userName } : { id: 0, userName: name };
    // });

    //List email input

    const userNameCcObj = userNameCc.map((obj) => {
      const user = userNameList.find(
        (user) => user.userName === obj.userEmailId
      );
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: obj.userEmailId };
    });
    // console.log("userNameCcObj", userNameCcObj, "userNameCc", userNameCc, "userNameList", userNameList);
    const selUserNameobj = selectedUserName.map((obj) => {
      const user = userNameList.find(
        (user) => user.userName === obj.userEmailId
      );
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: obj.userEmailId };
    });

    const selUserNameCcobj = selectedUserNameCc.map((obj) => {
      const user = userNameList.find(
        (user) => user.userName === obj.userEmailId
      );
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: obj.userEmailId };
    });

    //
    const userNameInputCcObj = userNameInputCc.map((name) => {
      const user = userNameListInput.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selUserNameInputobj = selectedUserNameInput.map((name) => {
      const user = userNameListInput.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selUserNameInputCcobj = selectedUserNameInputCc.map((name) => {
      const user = userNameListInput.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });

    //List Email
    const userGroupCcObj = userGroupCc.map((name) => {
      const user = userGroupList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selUserGroupobj = selectedUserGroup.map((name) => {
      const user = userGroupList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selUserGroupCcobj = selectedUserGroupCc.map((name) => {
      const user = userGroupList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });

    //Role
    const roleListCcObj = roleListCc.map((name) => {
      const user = userRolesList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selRoleListobj = selectedRoleList.map((name) => {
      const user = userRolesList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selRoleListCcobj = selectedRoleListCc.map((name) => {
      const user = userRolesList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    //PlaceHolderList
    const placeHoldolderCcObj = placeHoldolderCc.map((name) => {
      const user = placeHolderList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selplaceHoldoldertobj = selectedPlaceHolderList.map((name) => {
      const user = placeHolderList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    const selplaceHoldolderCcobj = selectedPlaceHolderListCc.map((name) => {
      const user = placeHolderList.find((user) => user.userName === name);
      return user
        ? { id: user.id, userName: user.userName }
        : { id: 0, userName: name };
    });
    console.log(
      "userNameCcObj",
      userNameCcObj,
      "selUserNameobj",
      selUserNameobj,
      "selUserNameCcobj",
      selUserNameCcobj
    );

    if (selUserNameobj) {
      updatePayLoads.push(
        ...selUserNameobj.map((user) => {
          const isCC = selUserNameCcobj.some(
            (ccUser) => ccUser.userName === user.userName
          );
          console.log(
            "UserNameCheck ",
            "selUserNameobj",
            selUserNameobj,
            "user",
            user,
            "isCC",
            isCC
          );
          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            userCategory: "Users",
            emailTo: true,
            emailCC: isCC ? true : false,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selUserNameInputobj) {
      updatePayLoads.push(
        ...selUserNameInputobj.map((user) => {
          const isCC = selUserNameInputCcobj.some(
            (ccUser) => ccUser.userName === user.userName
          );
          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            // userCategory: "",
            emailTo: true,
            emailCC: isCC ? true : false,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selUserGroupobj) {
      updatePayLoads.push(
        ...selUserGroupobj.map((user) => {
          const isCC = selUserGroupCcobj.some(
            (ccUser) => ccUser.userName === user.userName
          );
          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            userCategory: "Groups",
            emailTo: true,
            emailCC: isCC ? true : false,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selRoleListobj) {
      updatePayLoads.push(
        ...selRoleListobj.map((user) => {
          const isCC = selRoleListCcobj.some(
            (ccUser) => ccUser.userName === user.userName
          );
          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            userCategory: "Roles",
            emailTo: true,
            emailCC: isCC ? true : false,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (selplaceHoldoldertobj) {
      updatePayLoads.push(
        ...selplaceHoldoldertobj.map((user) => {
          const isCC = selplaceHoldolderCcobj.some(
            (ccUser) => ccUser.userName === user.userName
          );
          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            userCategory: "PlaceHolder",
            emailTo: true,
            emailCC: isCC ? true : false,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (userNameCcObj) {
      updatePayLoads.push(
        ...userNameCcObj.map((user) => {
          console.log(
            "UserNameCheck CC ",
            "userNameCcObj",
            userNameCcObj,
            "user",
            user
          );

          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            userCategory: "Users",
            emailTo: false,
            emailCC: true,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (userNameInputCcObj) {
      updatePayLoads.push(
        ...userNameInputCcObj.map((user) => {
          return {
            id: user.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: user.userName,
            // userCategory: "",
            emailTo: false,
            emailCC: true,
            updateDate: user.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: user.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (userGroupCcObj) {
      updatePayLoads.push(
        ...userGroupCcObj.map((group) => {
          return {
            id: group.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: group.userName,
            userCategory: "Groups",
            emailTo: false,
            emailCC: true,
            updateDate:
              group.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: group.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (roleListCcObj) {
      updatePayLoads.push(
        ...roleListCcObj.map((role) => {
          return {
            id: role.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: role.userName,
            userCategory: "Roles",
            emailTo: false,
            emailCC: true,
            updateDate: role.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: role.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }
    if (placeHoldolderCcObj) {
      updatePayLoads.push(
        ...placeHoldolderCcObj.map((role) => {
          return {
            id: role.id,
            emailTaskId: emailTaskIdValue.emailTaskId,
            userName: role.userName,
            userCategory: "PlaceHolder",
            emailTo: false,
            emailCC: true,
            updateDate: role.id > 0 ? new Date(Date.now()).toISOString() : null,
            updateUser: role.id > 0 ? authUser.userId + "" : null,
            createDate: new Date(Date.now()).toISOString(),
            createUser: authUser.userId + "",
          };
        })
      );
    }

    console.log("PayLoad##", updatePayLoads, delPayLoad);
    return { updatePayLoads, delPayLoad };
  };

  const handleSubmit = async () => {
    setIsFormSubmitted(true);
    setIsLoading(true);
    let hasRecipientValidation = false;
    console.log("hasRecipientValidationbef", hasRecipientValidation);
    hasRecipientValidation =
      selectedUserName.length === 0 &&
        selectedUserGroup.length === 0 &&
        selectedPlaceHolderList.length === 0 &&
        selectedRoleList.length === 0 &&
        selectedUserNameInput.length === 0
        ? true
        : false;
    if (hasRecipientValidation) {
      setIsRecipientValidation(true);
    }

    const baseUrl = `${API_BASE_URL}/Application/CreateEmailUser`;
    const baseUrlUpd = `${API_BASE_URL}/Application/UpdateEmailUser`;
    try {
      let envLink = null;
      if (env === "DEV") {
        envLink = envUrls.Dev;
      } else if (env === "QA") {
        envLink = envUrls.Qa;
      } else if (env === "UAT") {
        envLink = envUrls.Uat;
      } else if (env === "Prod") {
        envLink = envUrls.Prod;
      }
      // let paragraphMsg = formValues.html
      //   ? `<html><body>` +
      //   formValues.Mail_Message.replaceAll("\n", "<br/>") +
      //   `<a href="${envLink}">TrackNowLogin</a>` +
      //   `</body></html>`
      //   : formValues.Mail_Message.replaceAll("\n", "") + `<a href="${envLink}">TrackNowLogin</a>`;

      let paragraphMsg =
        `<html><body>` +
        // `<b>[TEST EMAIL – SYSTEM GENERATED]</b><br/><br/>` +
        `Please click on this link to Login:<br/>` +
        `<a href="${envLink}">TrackNowLogin</a>` +
        `<hr/><br/>` +
        formValues.Mail_Message.replaceAll("\n", "<br/>") +
        `<br/>` +
        `</body></html>`;

      let threeDigitReminder = ("000" + formValues.Mail_ReminderBefore).substr(
        -3
      );
      let client = formValues.Client ? formValues.Client.code : "default";
      let findClient = initialFormValues.filter((key) => key.Client === client);
      let isExist =
        findClient.length > 0 &&
        Object.keys(findClient[0].data).filter(
          (key) => key.slice(-3) === threeDigitReminder
        );
      const isReminderTab = tabValue === 0;
      const isOtherTabs = tabValue === 1 || tabValue === 2;
      let hasRequired =
        !formValues.Mail_Message ||
        !formValues.Mail_Subject ||
        (isReminderTab && (
          !formValues.Mail_ReminderBefore ||
          formValues.Mail_ReminderBefore < 0 ||
          !formValues.Due_Date_Type
        )) ||  // ✅ NEW: Client mandatory for tab 1 & 2
        (isOtherTabs && !formValues.Client)
        ||
        Boolean(emailError) ||
        Boolean(emailError);
      let reminderUpdatePayLoads = null;
      let reminderPayLoads = null;
      let preFix = tabValue == 1 ? "PastDue_" : tabValue == 2 ? "Completed_" : `Reminder_${formValues.Mail_ReminderBefore}_`

      const emailTaskName = `${preFix}${formValues.Client ? formValues.Client.name : "null"
        }`;
      try {
        reminderPayLoads = {
          emailTaskId: 0,
          emailSubject: formValues.Mail_Subject,
          emailMessage: paragraphMsg,
          isHTMLMessage: true,
          isReminder: tabValue == 0 ? true : false,
          emailTaskName: emailTaskName,
          ...(tabValue == 0 && { reminderStartInDays: -formValues.Mail_ReminderBefore }),
          ...(tabValue == 0 && { reminderFrequencyInDays: 1 }),
          ...(tabValue == 0 && { reminderBasedOnField: "FilingDueDate" }),
          customerId: formValues.Client ? formValues.Client.code : null,
          createDate: new Date(Date.now()).toISOString(),
          createUser: authUser.userId + "",
          recordType: formValues.RecordType,
          isActive: formValues.Notifications,
        };
        reminderUpdatePayLoads = {
          emailTaskId: emailTaskIdValue?.emailTaskId,
          emailSubject: formValues.Mail_Subject,
          emailMessage: paragraphMsg,
          isHTMLMessage: true,
          isReminder: tabValue == 0 ? true : false,
          emailTaskName: emailTaskName,
          ...(tabValue == 0 && { reminderStartInDays: -formValues.Mail_ReminderBefore }),
          isActive: formValues.Notifications,
          ...(tabValue == 0 && { reminderFrequencyInDays: 1 }),
          ...(tabValue == 0 && { reminderBasedOnField: "FilingDueDate" }),
          customerId: formValues.Client ? formValues.Client.code : null,
          createDate: new Date(Date.now()).toISOString(),
          createUser: authUser.userId + "",
          recordType: formValues.RecordType,
          updateDate: new Date(Date.now()).toISOString(),
          updateUser: authUser.userId + "",
        };

      } catch (error) {
        console.log("error#", error);
      }
      if (!hasRequired && !hasRecipientValidation) {
        if (isCreating) {
          if (isExist.length > 0) {
            setAlertMessage("Reminder already exists");
            setShowAlert(true);
            return;
          }

          try {
            let res = await createEmail(reminderPayLoads);
            if (res.data.status === "Success") {
              let resRecipient = await handlePayLoad(res.data.data.emailTaskId);
              if (resRecipient) {
                const responseRecipent = await axios.post(baseUrl, resRecipient);
                console.log("DIALOG POPUP responseRecipent", responseRecipent);

                try {
                  const responses =
                    responseRecipent.data.status === "Success" ? true : false;
                  console.log("DIALOG POPUP responseRecipent", responses);

                  if (responses) {
                    setAlertMessage("Sucessfully created reminder");
                    setShowAlert(true);
                  } else {
                    setAlertMessage("Error adding recipients");
                    setShowAlert(true);
                  }
                } catch (error) {
                  console.error("Error:", error);
                }
              }
            } else {
              setAlertMessage("Error creating reminder");
              setShowAlert(true);
            }
          } finally {
            setSelectedPlaceHolderList([]);
            setIsFormSubmitted(false);
            getConfigs();
            handleReset();
            setSelectedUserNameCc([]);
            setSelectedUserNameInputCc([]);
            setSelectedUserGroup([]);
            setSelectedUserName([]);
            setSelectedUserNameInput([]);
            setSelectedEmailsCombained([]);
            setSelectedRoleList([]);
            setSelectedPlaceHolderListCc([]);
            setSelectedUserGroupCc([]);
            setSelectedUserNameCc([]);
            setSelectedRoleListCc([]);
            setEmailTaskIdValue(null);
            // setSelectedReminderName('')
            console.log("sucesss", 123);
          }
        } else {
          if (isExist.length > 0) {
            setAlertMessage("Reminder already exists");
            setShowAlert(true);
            handleReset();

            return;
          }

          let res = await updateEmail(reminderUpdatePayLoads);
          const { updatePayLoads, delPayLoad } = await updateRecipient();

          if (updatePayLoads) {
            const newlyAddedUser = updatePayLoads.filter(
              (item) => item.id === 0
            ); // newly added cc or to
            const exsistingUser = updatePayLoads.filter(
              (item) => item.id !== 0
            ); // exsisting cc or to modification
            const removeMatchingObjects = (initialArr, exsistingArr) => {
              return exsistingArr.filter((exsistingObj) => {
                // Ensure exsistingObj is defined
                if (!exsistingObj || typeof exsistingObj !== "object") {
                  return true; // Keep the object if it is not valid
                }

                // Check if there is a matching initialEmailCcandTo object with the same id
                let matchingInitialObj = initialArr.find((initialObj) => {
                  return (
                    initialObj &&
                    typeof initialObj === "object" &&
                    initialObj.id === exsistingObj.id &&
                    initialObj.emailCC === exsistingObj.emailCC &&
                    initialObj.emailTo === exsistingObj.emailTo
                  );
                });

                // If matchingInitialObj is found, filter it out from exsistingArr
                return !matchingInitialObj;
              });
            };

            // Example usage:
            let filteredExsistingUser = removeMatchingObjects(
              initialEmailCCandTo,
              exsistingUser
            );
            // removing the exsisting EmailCc and EmailTo if not edited
            // console.log("updatePayLoads", updatePayLoads, "newlyAddedUser", newlyAddedUser, "exsistingUser", exsistingUser,);

            for (const resUpd of filteredExsistingUser) {
              const urlWithId = `${baseUrlUpd}?Id=${resUpd.id}`;
              let responseRecipentUpd = await axios.put(urlWithId, resUpd);
            }
            //Calling create API for newly added user
            const urlWithId = `${baseUrl}`;
            let responseRecipentUpd = await axios.post(
              urlWithId,
              newlyAddedUser
            );
          }
          if (delPayLoad) {

            // Assuming delUserId is the value you want to send for deletion
            try {
              const response = await axios.delete(
                `${API_BASE_URL}/Application/DeleteEmailUser?UpdateUser=${authUser.userId + ""
                }`,
                { data: delPayLoad }
              );
              // Handle the response as needed (e.g., check for success)
              //console.log(`Deleted user with ID ${delId}`);
            } catch (error) {
              // Handle any errors that may occur during the DELETE request
              //console.error(`Error deleting user with ID ${delId}:`, error);
            }
          }
          console.log("DIALOG POPUP res", res);

          if (res.data.status === "Success") {
            setAlertMessage("Reminder Successfully Updated");
            setShowAlert(true);
            handleReset();
            setIsFormSubmitted(false);
            setSelectedPlaceHolderList([]);
            setSelectedEmailsCombained([]);
            setSelectedUserGroup([]);
            setSelectedUserName([]);
            setSelectedRoleList([]);
            setSelectedPlaceHolderListCc([]);
            setSelectedUserGroupCc([]);
            setSelectedUserNameCc([]);
            setSelectedRoleListCc([]);
            //  setSelectedReminderName('')
            setEmailTaskIdValue(null);
            setIsFormSubmitted(false);
            getConfigs();
          } else {
            setAlertMessage("Error Updating Reminder");
            setShowAlert(true);
            handleReset();
            setIsFormSubmitted(false);
            setSelectedPlaceHolderList([]);
            setSelectedEmailsCombained([]);
            setSelectedUserGroup([]);
            setSelectedUserName([]);
            setSelectedRoleList([]);
            setSelectedPlaceHolderListCc([]);
            setSelectedUserGroupCc([]);
            setSelectedUserNameCc([]);
            setSelectedRoleListCc([]);
            //  setSelectedReminderName('')
            setEmailTaskIdValue(null);
            setIsFormSubmitted(false);
            getConfigs();
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSubmitCheck = async () => {
  //   let hasRecipientValidation = false;
  //   console.log("hasRecipientValidationbef", hasRecipientValidation);
  //   hasRecipientValidation = selectedUserName.length === 0 && selectedUserGroup.length === 0 && selectedPlaceHolderList.length === 0 && selectedRoleList.length === 0 ? true : false
  //   console.log("hasRecipientValidation", hasRecipientValidation);
  //   if (hasRecipientValidation) {
  //     setIsRecipientValidation(true)
  //   } else {
  //     setAlertMessage("Sucessfull");
  //     setShowAlert(true)
  //   }
  // }

  const handleReminder = (val) => {


    const isAllActive = selectedEmail.every((email) => email.isActive === true)
    const isAllInActive = selectedEmail.every((email) => email.isActive === false)

    if (isAllActive && val === "on") {
      setAlertMessage("All selected emails already have reminders turned on.");
      setShowAlert(true);
      return
    }
    if (isAllInActive && val === "off") {
      setAlertMessage("All selected emails already have reminders turned off.");
      setShowAlert(true);
      return
    }
    setNotifications(val)
    if (val === "on") {
      notificationsDialog(
        "Confirmation",
        "If Reminders is turned ON, system will send reminders to the selected Client users. Do you want to change?",
        "confirm"
      );
    } else {
      notificationsDialog(
        "Confirmation",
        "If Reminders is turned OFF, system will not send reminders to the selected Client users. Do you want to change?",
        "confirm"
      );
    }


  }
  const createEmail = async (reminderPayLoads) => {
    const baseUrl = `${API_BASE_URL}/Application/CreateEmail`;

    let res = await axios.post(baseUrl, reminderPayLoads);
    return res;
  };
  const updateEmail = async (reminderUpdatePayLoads) => {
    const baseUrl = `${API_BASE_URL}/Application/UpdateEmail?EmailTaskId=${reminderUpdatePayLoads.emailTaskId}`;

    let res = await axios.put(baseUrl, reminderUpdatePayLoads);
    console.log("emailRes", res);
    return res;
  };

  const getClientName = (clientId) => {
    let findName = customerList.filter((ele) => ele.code === clientId);
    return findName.length > 0 ? findName[0].name : "";
  };

  const EditButton = ({ rowData }) => {
    return (
      <GoogleIconButton
        iconName={ICONS.edit}
        iconColor={primaryColor}
        disabled={!usePermission("setting", "edit", rowData.clientId)}
        onClick={() => editReminder(rowData)}
        sx={{
          '&:hover': { backgroundColor: `${primaryColor}1A` },
          '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
        }}
      />
    );
  };

  const DeleteButton = ({ rowData }) => {
    return (
      <GoogleIconButton
        iconName={ICONS.delete}
        iconColor={primaryColor}
        disabled={!usePermission("setting", "edit", rowData.clientId)}
        onClick={() => handleDelete(rowData)}
        sx={{
          '&:hover': { backgroundColor: `${primaryColor}1A` },
          '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
        }}
      />
    );
  };

  const deleteReminder = async (showAlert) => {
    setIsLoading(true);
    try {
      console.log("deleteUser data", selectedReminder);
      const res = await axios.get(`${API_BASE_URL}/Application/ListEmailUsers`);
      const viewEmailUserList = res.data.data;
      const filteredEmailUserList = viewEmailUserList.filter(
        (email) => email.emailTaskId === emailTaskIdValue.emailTaskId
      );
      console.log("filteredEmailUserList", filteredEmailUserList);
      const delEmailIds = filteredEmailUserList.map((item) => item.id);
      try {
        let response;
        let res = await axios.delete(
          `${API_BASE_URL}/Application/DeleteEmail/${selectedReminder.emailTaskId}`
        );
        console.log("res", res.data);

        if (res.data.status === "Success") {
          try {
            if (delEmailIds.length > 0) {
              console.log("delEmailIds", delEmailIds);

              // Assuming delUserId is the value you want to send for deletion
              try {
                response = await axios.delete(
                  `${API_BASE_URL}/Application/DeleteEmailUser?UpdateUser=${authUser.userId + ""
                  }`,
                  { data: delEmailIds }
                );
                // console.log(`Deleted user with ID ${delId}`);
              } catch (error) {
                // console.error(`Error deleting user with ID ${delId}:`, error);
              }
            }
          } finally {
            setAlertMessage("Reminder successfully deleted");
            setShowAlert(true);
          }
          // getConfigs();
          // handleReset()
        } else {
          setAlertMessage(res.data.errorMessage);
          setShowAlert(true);
          // getConfigs();
          // handleReset()
        }
      } catch (error) {
        console.log(error);
      }
    } finally {
      setIsLoading(false);
      getConfigs();
      handleReset();
      setEmailTaskIdValue(null);
    }
  };

  const { AlertDialog: ConfirmDialog, showDialog } = useDialog({
    onSubmit: deleteReminder,
  });

  const handleDelete = (data) => {
    console.log("handleDelete data", data);
    setSelectedReminder(data);
    setEmailTaskIdValue(data);
    showDialog(
      "Confirmation",
      "Are you sure you want to delete this reminder?",
      "confirm"
    );
  };

  const isPermission = !usePermission("setting", "edit");

  const editReminder = async (data) => {
    try {

      setIsCreating(false);
      setIsRecipientValidation(false);
      setSelectedReminder(data);
      setEmailTaskIdValue(data);
      // setSelectedReminderName(data.emailTaskName)
      let resData = await axios.get(
        `${API_BASE_URL}/Application/ListEmailMasterPlaceHolderNameValues`
      );
      let userTable = resData.data.data.filter(
        (item) =>
          item.isReplacerName === false &&
          item.isGroupName === false &&
          item.isUsername === true &&
          item.isRoleName === false
      );
      let res = await axios.get(`${API_BASE_URL}/Application/ListEmailUsers`);
      let viewEmailUserList = res.data.data;
      let filteredEmailUserList = viewEmailUserList.filter(
        (email) => email.emailTaskId === data.emailTaskId
      );
      // let userName = filteredEmailUserList.filter(
      //   (cat) => cat.userCategory === "Users"
      // );
      let filtUsers = filteredEmailUserList.filter(
        (cat) => cat.userCategory === "Users"
      );
      const userList = filtUsers.map((user) => {
        const matchingUser = userTable.find(
          (userNameObj) => userNameObj.userEmailId === user.userName
        );
        if (matchingUser) {
          console.log("matchingUser", matchingUser);
          return {
            ...user,
            placeHolderName: matchingUser.placeHolderName,
          };
        }
      });


      let userNameInput = filteredEmailUserList.filter(
        (cat) => cat.userCategory === null
      );
      let userGroup = filteredEmailUserList.filter(
        (cat) => cat.userCategory === "Groups"
      );
      let userRoles = filteredEmailUserList.filter(
        (cat) => cat.userCategory === "Roles"
      );
      let placeHolder = filteredEmailUserList.filter(
        (cat) => cat.userCategory === "PlaceHolder"
      );
      let combainedEmailCcandTo = [
        ...userList,
        ...userNameInput,
        ...userRoles,
        ...placeHolder,
      ];
      console.log("editReminder combainedEmailCcandTo", combainedEmailCcandTo);
      setInitialEmailCCandTo(combainedEmailCcandTo);

      console.log(
        "editReminder",
        userList,
        "userNameInput",
        userNameInput,
        "userRoles",
        userRoles,
        "placeHolder",
        placeHolder
      );
      let userNameSel = [];
      let userNameCcSel = [];
      userList.forEach((email) => {
        const userEntry = {
          userEmailId: email?.userName,
          placeHolderName: email?.placeHolderName,
        };
        if (email?.emailCC && email?.emailTo) {
          userNameSel.push(userEntry);
          userNameCcSel.push(userEntry);
        } else if (email?.emailTo) {
          userNameSel.push(userEntry);
        } else if (email?.emailCC) {
          userNameCcSel.push(userEntry);
        }
      });
      setSelectedUserName(userNameSel);
      setSelectedUserNameCc(userNameCcSel);
      setSelectedEmailsCombained([...userNameSel, ...userNameCcSel]);

      let userNameSelInput = [];
      let userNameCcSelInput = [];
      userNameInput.forEach((email) => {
        if (email?.emailCC && email?.emailTo) {
          userNameSelInput.push(email.userName);
          userNameCcSelInput.push(email.userName);
        } else if (email?.emailTo) {
          userNameSelInput.push(email.userName);
        } else if (email?.emailCC) {
          userNameCcSelInput.push(email.userName);
        }
      });
      setSelectedUserNameInput(userNameSelInput);
      setSelectedUserNameInputCc(userNameCcSelInput);
      setSelectedEmailsCombained([...userNameSelInput, ...userNameSelInput]);

      let userGroupSel = [];
      let userGroupCcSel = [];
      userGroup.forEach((email) => {
        if (email?.emailCC && email?.emailTo) {
          userGroupSel.push(email.userName);
          userGroupCcSel.push(email.userName);
        } else if (email?.emailTo) {
          userGroupSel.push(email.userName);
        } else if (email?.emailCC) {
          userGroupCcSel.push(email.userName);
        }
      });

      setSelectedUserGroup(userGroupSel);
      setSelectedUserGroupCc(userGroupCcSel);
      setSelectedEmailsCombained([...userGroupSel, ...userGroupCcSel]);

      let RoleListSel = [];
      let RoleListCcSel = [];
      userRoles.forEach((email) => {
        if (email?.emailCC && email?.emailTo) {
          RoleListSel.push(email.userName);
          RoleListCcSel.push(email.userName);
        } else if (email?.emailTo) {
          RoleListSel.push(email.userName);
        } else if (email?.emailCC) {
          RoleListCcSel.push(email.userName);
        }
      });
      setSelectedRoleList(RoleListSel);
      setSelectedRoleListCc(RoleListCcSel);
      setSelectedEmailsCombained([...RoleListSel, ...RoleListCcSel]);

      let PlaceHolderListSel = [];
      let PlaceHolderListCcSel = [];
      placeHolder.forEach((email) => {
        if (email?.emailCC && email?.emailTo) {
          PlaceHolderListSel.push(email.userName);
          PlaceHolderListCcSel.push(email.userName);
        } else if (email?.emailTo) {
          PlaceHolderListSel.push(email.userName);
        } else if (email?.emailCC) {
          PlaceHolderListCcSel.push(email.userName);
        }
      });
      setSelectedPlaceHolderList(PlaceHolderListSel);
      setSelectedPlaceHolderListCc(PlaceHolderListCcSel);
      setSelectedEmailsCombained([
        ...PlaceHolderListSel,
        ...PlaceHolderListCcSel,
      ]);


      let envLink = "";
      if (env === "DEV") {
        envLink = envUrls.Dev;
      } else if (env === "QA") {
        envLink = envUrls.Qa;
      } else if (env === "UAT") {
        envLink = envUrls.Uat;
      } else if (env === "Prod") {
        envLink = envUrls.Prod;
      }
      let text = data.emailMessage
        .replaceAll("<br/>", "\n")
        .replace(/<hr\/>|<br\/>|Please click on this link to Login:/gi, "")
        // .replace(/<b>\[TEST EMAIL – SYSTEM GENERATED\]<\/b>/gi, "")
        .replace(
          new RegExp(`<a[^>]*href="${envLink}"[^>]*>(.*?)<\/a>`, "gi"),
          ""
        )
        .slice(12, -14)
        .trim();
      setInitialValues({
        Mail_Subject: data.emailSubject,
        Mail_ReminderBefore: Math.abs(parseInt(data.reminderStartInDays)),
        Client: data.customerId
          ? { code: data.customerId, name: getClientName(data.customerId) }
          : "",
        RecordType: data.recordType,
        //Client: data.customerId ? data.customerId : "",
        Mail_Message: text,
        Due_Date_Type: "Filing",
        Notifications: data.isActive,
        //html: data.emailMessage.charAt(0) === "<",
        //html: data.isHTMLMessage
      });
      setFormValues({
        Mail_Subject: data.emailSubject,
        Mail_ReminderBefore:
          data.reminderStartInDays < 0
            ? Math.abs(parseInt(data.reminderStartInDays))
            : parseInt(data.reminderStartInDays),
        Client: data.customerId
          ? { code: data.customerId, name: getClientName(data.customerId) }
          : "",
        RecordType: data.recordType,
        //Client: data.customerId ? data.customerId : "",
        Mail_Message: text,
        Due_Date_Type: "Filing",
        Notifications: data.isActive,
        //html: data.emailMessage.charAt(0) === "<" ? true : false,
        //  html: data.isHTMLMessage
      });
    } catch (error) {
      console.log("EditError", error);
    }
  };
  // console.log("EmailTaskIdValue", emailTaskIdValue);
  // console.log("**initialValues", initialValues);
  // console.log("**formValues", formValues);


  const footerContent = (
    <div>
      <PrimeButton
        label="OK"
        icon="pi pi-check"
        onClick={() => closeAlert()}
        autoFocus
      />
    </div>
  );

  const closeAlert = () => {
    setShowAlert(false);
  };
  const renderDropdownItem = (option) => {
    if (!option) {
      return null;
    }

    const { name } = option;
    if (name && name.length > 25) {
      return (
        <Tooltip title={name} key={name}>
          <span>{name.substr(0, 25)}...</span>
        </Tooltip>
      );
    }
    return <span key={name}>{name}</span>;
  };
  const selectedValueTemplate = (option) => {
    if (!option) {
      return null;
    }

    const { name } = option;
    if (name && name.length > 25) {
      return (
        <Tooltip title={name} key={name}>
          <span>{name.substr(0, 25)}...</span>
        </Tooltip>
      );
    }
    return <span key={name}>{name}</span>;
  };
  const fetchReminderHistory = async (emailTaskId) => {
    try {
      let res = await axios.get(
        `${API_BASE_URL}/Application/ReminderAudit?EmailTaskId=${emailTaskId}`
      );
      let history = res.data.data;
      // let history =
      //   [{
      //     "id": 1,
      //     "process": "Newly added",
      //     "createdate": null,
      //     "createuser": null,
      //     "updatedate": null,
      //     "updateuser": null,
      //     "historyId": 0,
      //     "new_HistoryId": 0,
      //     "emailTaskId": 52,
      //     "emailTaskName": null,
      //     "new_EmailTaskName": null,
      //     "emailSubject": null,
      //     "new_EmailSubject": null,
      //     "emailMessage": null,
      //     "new_EmailMessage": null,
      //     "isHTMLMessage": null,
      //     "new_IsHTMLMessage": null,
      //     "isReminder": null,
      //     "new_IsReminder": null,
      //     "reminderStartInDays": null,
      //     "new_ReminderStartInDays": null,
      //     "reminderFrequencyInDays": null,
      //     "new_ReminderFrequencyInDays": null,
      //     "reminderBasedOnField": null,
      //     "new_ReminderBasedOnField": null,
      //     "customerId": null,
      //     "new_CustomerId": null,
      //     "filingId": null,
      //     "new_FilingId": null,
      //     "lastReminderDate": null,
      //     "new_LastReminderDate": null,
      //     "isActive": null,
      //     "new_IsActive": null,
      //     "reminderDate": null,
      //     "new_ReminderDate": null,
      //     "recordType": null,
      //     "new_RecordType": null,
      //     "userName": null,
      //     "new_UserName": null,
      //     "userCategory": null,
      //     "new_UserCategory": null,
      //     "emailTo": null,
      //     "new_EmailTo": null,
      //     "emailCC": null,
      //     "new_EmailCC": null,
      //     "emailBCC": null,
      //     "new_EmailBCC": null
      //   },
      //   {
      //     "id": 2,
      //     "process": "Newly added",
      //     "createdate": null,
      //     "createuser": null,
      //     "updatedate": null,
      //     "updateuser": null,
      //     "historyId": 0,
      //     "new_HistoryId": 0,
      //     "emailTaskId": 52,
      //     "emailTaskName": null,
      //     "new_EmailTaskName": null,
      //     "emailSubject": null,
      //     "new_EmailSubject": null,
      //     "emailMessage": null,
      //     "new_EmailMessage": null,
      //     "isHTMLMessage": null,
      //     "new_IsHTMLMessage": null,
      //     "isReminder": null,
      //     "new_IsReminder": null,
      //     "reminderStartInDays": null,
      //     "new_ReminderStartInDays": null,
      //     "reminderFrequencyInDays": null,
      //     "new_ReminderFrequencyInDays": null,
      //     "reminderBasedOnField": null,
      //     "new_ReminderBasedOnField": null,
      //     "customerId": null,
      //     "new_CustomerId": null,
      //     "filingId": null,
      //     "new_FilingId": null,
      //     "lastReminderDate": null,
      //     "new_LastReminderDate": null,
      //     "isActive": null,
      //     "new_IsActive": null,
      //     "reminderDate": null,
      //     "new_ReminderDate": null,
      //     "recordType": null,
      //     "new_RecordType": null,
      //     "userName": null,
      //     "new_UserName": null,
      //     "userCategory": null,
      //     "new_UserCategory": null,
      //     "emailTo": null,
      //     "new_EmailTo": null,
      //     "emailCC": null,
      //     "new_EmailCC": null,
      //     "emailBCC": null,
      //     "new_EmailBCC": null
      //   },
      //   {
      //     "id": 3,
      //     "process": "Newly added",
      //     "createdate": "2024-07-02T07:55:50.62",
      //     "createuser": "184",
      //     "updatedate": null,
      //     "updateuser": null,
      //     "historyId": 0,
      //     "new_HistoryId": 0,
      //     "emailTaskId": 52,
      //     "emailTaskName": null,
      //     "new_EmailTaskName": "Reminder_2_ABC KT",
      //     "emailSubject": null,
      //     "new_EmailSubject": "Test subject",
      //     "emailMessage": null,
      //     "new_EmailMessage": "<html><body>Please click on this link to Login:<br/><a href=\"jsi-tracknow-cert.azurewebsites.net\">TrackNowLogin</a><hr/><br/>Test Message<br/></body></html>",
      //     "isHTMLMessage": null,
      //     "new_IsHTMLMessage": true,
      //     "isReminder": null,
      //     "new_IsReminder": true,
      //     "reminderStartInDays": null,
      //     "new_ReminderStartInDays": -2,
      //     "reminderFrequencyInDays": null,
      //     "new_ReminderFrequencyInDays": 1,
      //     "reminderBasedOnField": null,
      //     "new_ReminderBasedOnField": "FilingDueDate",
      //     "customerId": null,
      //     "new_CustomerId": 249,
      //     "filingId": null,
      //     "new_FilingId": null,
      //     "lastReminderDate": null,
      //     "new_LastReminderDate": null,
      //     "isActive": null,
      //     "new_IsActive": true,
      //     "reminderDate": null,
      //     "new_ReminderDate": null,
      //     "recordType": null,
      //     "new_RecordType": "PostAward",
      //     "userName": null,
      //     "new_UserName": "Colleen.Cook@jsitel.com, swapnag@infinite.com, Evette.Head@jsitel.com",
      //     "userCategory": null,
      //     "new_UserCategory": "Users, Users, Users",
      //     "emailTo": null,
      //     "new_EmailTo": "False, True, True",
      //     "emailCC": null,
      //     "new_EmailCC": "True, False, False",
      //     "emailBCC": null,
      //     "new_EmailBCC": "False, False, False"
      //   }
      //   ]
      setActivityHistory(() => history);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const displayHomePage = () => {
    navigate("/");
  };
  const displayTrackNowFilingMasterList = () => {
    navigate("/filing-master-list");
  };
  const displayPostAwardFilingMasterList = () => {
    navigate("/postaward-filing-master-list");
  };
  const displayClientFilingTrackerList = () => {
    navigate("/client-filing-tracker-list");
  };

  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };
  const displayHistory = async () => {
    if (selectedEmail && selectedEmail.emailTaskId) {
      fetchReminderHistory(selectedEmail.emailTaskId);
      setShowHistory(() => true);
    } else {
      setAlertMessage("Please Select a reminder");
      setShowAlert(true);
      // closeDialog();
    }
  };

  const isFormChanged =
    JSON.stringify(formValues) !== JSON.stringify(initialFormValues);
  console.log("isFormChanged", isFormChanged);
  // console.log("selectedEmail", selectedEmail);
  const handleSelect = (e) => {
    // console.log("handleSelect e", e);
    setSelectedEmail(e.value);
  };
  return (
    <React.Fragment>
      {isLoading ? (
        // Display the loading indicator
        <Loader /> // Replace with your loading component
      ) : (
        <Stack
          direction="column"
          spacing={2}
          sx={{ m: 1, width: "100%" }}
        >
          <Stack
            direction="row"
            sx={{
              width: "100%",
              alignItems: "flex-start",
            }}
          >
            <Container
              disableGutters
              maxWidth={false}
              className="reminderContainer"
              sx={{
                flex: 1,
                width: "100%",
                maxWidth: "90vw !important",
                mx: "auto",
                borderRadius: "10px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.4)",
                backgroundColor: tokens.colors.offWhite,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Box sx={{ p: { xs: 2, md: "30px 2rem" } }}>
                <Stack direction="column" spacing={4}>
                  <Stack direction="row" justifyContent="space-between">
                    <div>
                      <Typography style={{ fontWeight: "bold" }}>
                        REMINDER CONFIGURATION
                      </Typography>
                    </div>
                    <div>
                      <Stack spacing={3} direction="row">
                        <Stack>
                          <Button
                            sx={{
                              ...mailButtonStyle,
                              "&:hover": {
                                backgroundColor:
                                  mailButtonStyle.backgroundColor,
                              },
                            }}
                          >
                            E-Mail
                          </Button>
                        </Stack>
                      </Stack>
                    </div>
                  </Stack>
                  {/* ADD three tab, Reminder and completed here  */}
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    sx={{
                      borderBottom: "1px solid #ccc",
                      minHeight: "40px",
                    }}
                  >
                    <Tab label="Reminder" sx={{ textTransform: "none" }} />
                    <Tab label="Past Due" sx={{ textTransform: "none" }} />
                    <Tab label="Completed" sx={{ textTransform: "none" }} />
                    <Tab label="Weekly Filing Digest" sx={{ textTransform: "none" }} />
                  </Tabs>

                  {/* ── Existing form: Reminder / Past Due / Completed tabs (hidden on Weekly Digest) ── */}
                  {tabValue !== 3 && (
                    <React.Fragment>
                      <Stack direction="row" justifyContent="space-between">
                    <div style={{ width: "100%", marginRight: "1rem" }}>
                      <Stack direction="column" spacing={2}>
                        <Stack direction="row" spacing={3}>

                          <TrackNowSelect
                            sx={{ width: 400 }}
                            name="Client"
                            label="Client"
                            required={tabValue === 1 || tabValue === 2}
                            value={formValues.Client?.code || ""}
                            onChange={(e) => {
                              const selectedClient = customerList.find(item => item.code === e.target.value);
                              handleConfigItemChange({
                                target: {
                                  name: "Client",
                                  value: selectedClient || ""
                                }
                              });
                            }}
                            error={isFormSubmitted && (tabValue === 1 || tabValue === 2) && !formValues.Client}
                            helperText={
                              isFormSubmitted && (tabValue === 1 || tabValue === 2) && !formValues.Client
                                ? "Please select client"
                                : ""
                            }
                            fullWidth
                            displayEmpty
                          >
                            <MenuItem value="">Select client</MenuItem>
                            {customerList.map((item) => (
                              <MenuItem key={item.code} value={item.code}>
                                {item.name.length > 25 ? (
                                  <Tooltip title={item.name}>
                                    <span>{item.name.substr(0, 25)}...</span>
                                  </Tooltip>
                                ) : (
                                  item.name
                                )}
                              </MenuItem>
                            ))}
                          </TrackNowSelect>


                          <div style={{ width: "100%" }}>
                            <TrackNowSwitchField
                              name="Notifications"
                              label="Enable Notification"
                              checked={formValues.Notifications}
                              onChange={handleNotificationChange}
                            />
                          </div>

                        </Stack>
                        <Stack
                          direction="row"
                          spacing={1}
                          style={{ marginTop: "10px" }}
                        >

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                          >
                            <Stack>
                              <Stack direction="row" spacing={1}>
                                <TrackNowTextField
                                  sx={{ width: 400 }}
                                  label="Recipient"
                                  required
                                  id="recipientMail"
                                  placeholder="Email address"
                                  value={emailInput}
                                  onChange={handleEmailInputChange}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      handleAddEmailChip();
                                    }
                                  }}
                                  fullWidth
                                  error={Boolean(emailError)}
                                  helperText={emailError}
                                />
                                <GoogleIconButton
                                  iconName="add_circle"
                                  iconColor={primaryColor}
                                  onClick={handleOpenMenu}
                                  sx={{
                                    '&:hover': { backgroundColor: `${primaryColor}1A` },
                                    '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
                                  }}
                                />
                              </Stack>
                              {isRecipientValidation && (
                                <Typography
                                  style={{ fontSize: "0.8rem" }}
                                  color="error"
                                >
                                  Please Enter Recipient
                                </Typography>
                              )}
                            </Stack>
                            {/* <TextField sx={{ width: 200 }}
                              label="Reminder Name"
                              variant="outlined"
                              value={selectedReminderName}
                              disabled={!isCreating}
                              onChange={handleReminderName} /> */}
                          </Stack>

                          {/* <Paper style={{ padding: '10px' }}> */}

                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                          >
                            <MenuItem disabled>Emails:</MenuItem>
                            {userNameList.map((user, index) => {
                              const isSelected = selectedUserName.some(
                                (selectedUser) => selectedUser.userEmailId === user.userEmailId
                              );
                              return (
                                <MenuItem
                                  key={`email_${index}`}
                                  onClick={() =>
                                    handleSelectedValueUserName(user)
                                  }
                                  sx={{
                                    backgroundColor: isSelected ? `${primaryColor}14` : 'transparent',
                                    '&:hover': { backgroundColor: isSelected ? `${primaryColor}22` : undefined },
                                  }}
                                >
                                  <ListItemIcon>
                                    <GoogleMaterialIcon name="add_circle" color={primaryColor} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={`${user.placeHolderName} (${user.userEmailId})`}
                                    primaryTypographyProps={{
                                      color: isSelected ? primaryColor : 'inherit',
                                      fontWeight: isSelected ? 600 : 400,
                                    }}
                                  />
                                  {isSelected ? (
                                    <GoogleMaterialIcon name="check_circle" color={primaryColor} />
                                  ) : null}
                                </MenuItem>
                              );
                            })}

                            <MenuItem disabled>Place Holders:</MenuItem>
                            {placeHolderList.map((email, index) => {
                              const cleanedPlaceHolderName =
                                email.placeHolderName.replace(/{{|}}/g, "");
                              const isSelected = selectedPlaceHolderList.includes(email.placeHolderName);

                              return (
                                <MenuItem
                                  key={`email_${index}`}
                                  onClick={() =>
                                    handleSelectPlaceHolderList(
                                      email.placeHolderName
                                    )
                                  }
                                  sx={{
                                    backgroundColor: isSelected ? `${primaryColor}14` : 'transparent',
                                    '&:hover': { backgroundColor: isSelected ? `${primaryColor}22` : undefined },
                                  }}
                                >
                                  <ListItemIcon>
                                    <GoogleMaterialIcon name="add_circle" color={primaryColor} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={cleanedPlaceHolderName}
                                    primaryTypographyProps={{
                                      color: isSelected ? primaryColor : 'inherit',
                                      fontWeight: isSelected ? 600 : 400,
                                    }}
                                  />
                                  {isSelected ? (
                                    <GoogleMaterialIcon name="check_circle" color={primaryColor} />
                                  ) : null}
                                </MenuItem>
                              );
                            })}

                            <MenuItem disabled>User Roles:</MenuItem>
                            {userRoleList &&
                              userRoleList.map((email, index) => {
                                const isSelected = selectedRoleList.includes(email.placeHolderName);
                                return (
                                  <MenuItem
                                    key={`email_${index}`}
                                    onClick={() =>
                                      handleSelectRoleName(email.placeHolderName)
                                    }
                                    sx={{
                                      backgroundColor: isSelected ? `${primaryColor}14` : 'transparent',
                                      '&:hover': { backgroundColor: isSelected ? `${primaryColor}22` : undefined },
                                    }}
                                  >
                                    <ListItemIcon>
                                      <GoogleMaterialIcon name="add_circle" color={primaryColor} />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={email.placeHolderName}
                                      primaryTypographyProps={{
                                        color: isSelected ? primaryColor : 'inherit',
                                        fontWeight: isSelected ? 600 : 400,
                                      }}
                                    />
                                    {isSelected ? (
                                      <GoogleMaterialIcon name="check_circle" color={primaryColor} />
                                    ) : null}
                                  </MenuItem>
                                );
                              })}
                          </Menu>
                        </Stack>
                        <div>
                          <div>
                            {selectedUserName.map((user, index) => (
                              <Chip
                                key={index}
                                label={user.placeHolderName}
                                onDelete={() => handleRemoveValue(user)}
                                style={{ margin: "5px" }}
                              />
                            ))}
                          </div>

                          {selectedUserNameInput.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              onDelete={() => handleRemoveValueInput(value)}
                              style={{ margin: "5px" }}
                            />
                          ))}
                          {selectedPlaceHolderList.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              onDelete={() => handleRemoveValuePlace(value)}
                              sx={{ margin: "4px" }}
                            />
                          ))}
                          {selectedRoleList.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              onDelete={() => handleRemoveValueRoles(value)}
                              sx={{ margin: "4px" }}
                            />
                          ))}
                        </div>
                        <Stack
                          direction="row"
                          spacing={1}
                          style={{ marginTop: "10px" }}
                        >

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                          >
                            <Stack direction="row" spacing={1}>
                              <TrackNowTextField
                                sx={{ width: 400 }}
                                id="cCMail"
                                label="CC"
                                placeholder="Email address"
                                value={emailInputCc}
                                onChange={handleEmailInputChangeCc}
                                onKeyDown={(event) => {
                                  if (event.key === "Enter") {
                                    handleAddEmailChipCc();
                                  }
                                }}
                                fullWidth
                                error={Boolean(emailErrorCc)}
                                helperText={emailErrorCc}
                              />

                              <GoogleIconButton
                                iconName="add_circle"
                                iconColor={primaryColor}
                                onClick={handleOpenMenuCc}
                                sx={{
                                  '&:hover': { backgroundColor: `${primaryColor}1A` },
                                  '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
                                }}
                              />
                            </Stack>
                          </Stack>

                          {/* <Paper style={{ padding: '10px' }}> */}

                          <Menu
                            anchorEl={anchorE2}
                            open={Boolean(anchorE2)}
                            onClose={handleCloseMenuCc}
                          >
                            <MenuItem disabled>Emails:</MenuItem>
                            {userNameListCc.map((user, index) => {
                              const isSelected = selectedUserNameCc.some(
                                (selectedUser) => selectedUser.userEmailId === user.userEmailId
                              );
                              return (
                                <MenuItem
                                  key={`email_${index}`}
                                  onClick={() =>
                                    handleSelectedValueUserNameCc(user)
                                  }
                                  sx={{
                                    backgroundColor: isSelected ? `${primaryColor}14` : 'transparent',
                                    '&:hover': { backgroundColor: isSelected ? `${primaryColor}22` : undefined },
                                  }}
                                >
                                  <ListItemIcon>
                                    <GoogleMaterialIcon name="add_circle" color={primaryColor} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={`${user.placeHolderName} (${user.userEmailId})`}
                                    primaryTypographyProps={{
                                      color: isSelected ? primaryColor : 'inherit',
                                      fontWeight: isSelected ? 600 : 400,
                                    }}
                                  />
                                  {isSelected ? (
                                    <GoogleMaterialIcon name="check_circle" color={primaryColor} />
                                  ) : null}
                                </MenuItem>
                              );
                            })}
                            <MenuItem disabled>Place Holders:</MenuItem>
                            {placeHolderListCc.map((email, index) => {
                              const cleanedPlaceHolderName =
                                email.placeHolderName.replace(/{{|}}/g, "");
                              const isSelected = selectedPlaceHolderListCc.includes(email.placeHolderName);
                              return (
                                <MenuItem
                                  key={`email_${index}`}
                                  onClick={() =>
                                    handleSelectPlaceHolderListCc(
                                      email.placeHolderName
                                    )
                                  }
                                  sx={{
                                    backgroundColor: isSelected ? `${primaryColor}14` : 'transparent',
                                    '&:hover': { backgroundColor: isSelected ? `${primaryColor}22` : undefined },
                                  }}
                                >
                                  <ListItemIcon>
                                    <GoogleMaterialIcon name="add_circle" color={primaryColor} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={cleanedPlaceHolderName}
                                    primaryTypographyProps={{
                                      color: isSelected ? primaryColor : 'inherit',
                                      fontWeight: isSelected ? 600 : 400,
                                    }}
                                  />
                                  {isSelected ? (
                                    <GoogleMaterialIcon name="check_circle" color={primaryColor} />
                                  ) : null}
                                </MenuItem>
                              );
                            })}
                            <MenuItem disabled>User Roles:</MenuItem>
                            {userRoleListCc &&
                              userRoleListCc.map((email, index) => {
                                const isSelected = selectedRoleListCc.includes(email.placeHolderName);
                                return (
                                  <MenuItem
                                    key={`email_${index}`}
                                    onClick={() =>
                                      handleSelectRoleNameCc(
                                        email.placeHolderName
                                      )
                                    }
                                    sx={{
                                      backgroundColor: isSelected ? `${primaryColor}14` : 'transparent',
                                      '&:hover': { backgroundColor: isSelected ? `${primaryColor}22` : undefined },
                                    }}
                                  >
                                    <ListItemIcon>
                                      <GoogleMaterialIcon name="add_circle" color={primaryColor} />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={email.placeHolderName}
                                      primaryTypographyProps={{
                                        color: isSelected ? primaryColor : 'inherit',
                                        fontWeight: isSelected ? 600 : 400,
                                      }}
                                    />
                                    {isSelected ? (
                                      <GoogleMaterialIcon name="check_circle" color={primaryColor} />
                                    ) : null}
                                  </MenuItem>
                                );
                              })}
                          </Menu>
                        </Stack>
                        <div>
                          {selectedUserNameCc.map((user, index) => (
                            <Chip
                              key={index}
                              label={user.placeHolderName}
                              onDelete={() => handleRemoveValueCc(user)}
                              style={{ margin: "5px" }}
                            />
                          ))}
                          {selectedUserNameInputCc.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              onDelete={() => handleRemoveValueInputCc(value)}
                              style={{ margin: "5px" }}
                            />
                          ))}
                          {/* {selectedUserGroupCc.map((value, index) => (
                          <Chip
                            key={index}
                            label={value}
                            onDelete={() => handleRemoveUserGroupCc(value)}
                            style={{ margin: "5px" }}
                          />
                        ))} */}
                          {selectedPlaceHolderListCc.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              onDelete={() => handleRemoveValuePlaceCc(value)}
                              sx={{ margin: "4px" }}
                            />
                          ))}
                          {selectedRoleListCc.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              onDelete={() => handleRemoveValueRolesCc(value)}
                              sx={{ margin: "4px" }}
                            />
                          ))}
                        </div>
                        <Stack direction="row" spacing={3}>
                          <div style={{ width: "100%" }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 400, color: tokens.colors.grey }}>Record Type</Typography>
                            <RadioGroup
                              row
                              name="RecordType"
                              value={formValues.RecordType || ""}
                              onChange={handleConfigItemChange}
                              sx={{ marginTop: "1rem" }}
                            >
                              <FormControlLabel
                                value="TrackNow"
                                control={<TrackNowRadio />}
                                label="TrackNow"
                              />
                              <FormControlLabel
                                value="PostAward"
                                control={<TrackNowRadio />}
                                label="PostAward"
                              />
                            </RadioGroup>
                          </div>
                        </Stack>
                        {tabValue == 0 &&
                          <Stack direction="row" spacing={3}>
                            <div>
                              <Typography sx={{ fontSize: '14px', fontWeight: 400, color: tokens.colors.grey }}> Reminder Before Filing</Typography>
                              <TrackNowTextField
                                placeholder="Enter Days *"
                                type="number"
                                name="Mail_ReminderBefore"
                                value={formValues.Mail_ReminderBefore}
                                onChange={handleConfigItemChange}
                                sx={{ width: "100%", paddingTop: "5px" }}
                                required
                                error={
                                  (isFormSubmitted && tabValue == 0 &&
                                    !formValues.Mail_ReminderBefore) ||
                                  parseInt(formValues.Mail_ReminderBefore) < 0
                                }
                                helperText={
                                  isFormSubmitted && tabValue == 0 &&
                                    !formValues.Mail_ReminderBefore
                                    ? "Please enter Reminder before filing"
                                    : parseInt(formValues.Mail_ReminderBefore) < 0
                                      ? "Please enter a non-negative value"
                                      : ""
                                }
                                inputProps={{
                                  min: 1,
                                }}
                              />
                            </div>
                            <div style={{ width: "100%" }}>
                              <Typography sx={{ fontSize: '14px', fontWeight: 400, color: tokens.colors.grey }}>Due Date Option</Typography>
                              <RadioGroup
                                row
                                name="Due_Date_Type"
                                value={formValues.Due_Date_Type || ""}
                                onChange={handleConfigItemChange}
                                sx={{ marginTop: "1rem" }}
                              >
                                <FormControlLabel
                                  value="Filing"
                                  control={<TrackNowRadio />}
                                  label="Filing"
                                />
                              </RadioGroup>
                              <Typography
                                sx={{
                                  fontSize: "11px",
                                  fontWeight: "small",
                                  marginTop: "1rem",
                                  color: "red",
                                  display:
                                    isFormSubmitted && tabValue == 0 && !formValues.Due_Date_Type
                                      ? "block"
                                      : "none",
                                }}
                              >
                                Please enter Due Date option
                              </Typography>
                            </div>
                          </Stack>}
                      </Stack>
                    </div>

                    <div
                      style={{
                        border: "1px solid #bcb6c8",
                        borderRadius: "12px",
                        backgroundColor: tokens.colors.offWhite,
                        padding: "12px",
                      }}
                    >
                      <Stack></Stack>

                      <Stack>
                        <TrackNowTextField
                          id="mail-subject"
                          label="Subject"
                          name="Mail_Subject"
                          placeholder="Subject"
                          sx={{ paddingTop: "10px", width: "530px" }}
                          value={formValues.Mail_Subject}
                          onChange={handleConfigItemChange}
                          required
                          error={isFormSubmitted && !formValues.Mail_Subject}
                          helperText={
                            isFormSubmitted && !formValues.Mail_Subject
                              ? "Subject is required"
                              : ""
                          }
                        />
                      </Stack>
                      <TrackNowTextField
                        label="Message"
                        placeholder="Max 8000 characters"
                        multiline
                        name="Mail_Message"
                        minRows={9}
                        value={formValues.Mail_Message}
                        sx={{ width: "530px", paddingTop: "12px" }}
                        onChange={(e) => {
                          if (e.target.value.length <= 8000) {
                            handleConfigItemChange(e);
                            setRemainingChars(8000 - e.target.value.length);
                          }
                        }}
                        required
                        error={isFormSubmitted && !formValues.Mail_Message}
                        helperText={
                          isFormSubmitted && !formValues.Mail_Message
                            ? "Enter a message"
                            : ""
                        }
                      />

                      <Typography
                        sx={{
                          fontSize: "11px",
                          fontWeight: "small",
                          color: remainingChars === 0 ? "red" : "inherit",
                          display: remainingChars === 8000 ? "none" : "block",
                        }}
                      >
                        {remainingChars} Characters left
                      </Typography>
                    </div>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between">
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}>Reminders</span>

                        <Button
                          variant="outlined" color="primary"
                          disabled={isPermission || selectedEmail.length === 0}
                          onClick={() => handleReminder("on")}
                        >
                          Turn On
                        </Button>

                        <Button
                          variant="outlined"
                          color="error"
                          disabled={isPermission || selectedEmail.length === 0}
                          onClick={() => handleReminder("off")}
                        >
                          Turn Off
                        </Button>
                      </div>

                    </div>
                    <div>
                      <TrackNowButton
                        variant="tertiary"
                        disabled={isPermission}
                        onClick={handleReset}
                      >
                        Reset
                      </TrackNowButton>
                      {isCreating ? (
                        <TrackNowButton
                          variant="primary"
                          disabled={!isFormChanged || isPermission}
                          onClick={handleSubmit}
                        >
                          Save
                        </TrackNowButton>
                      ) : (
                        <TrackNowButton
                          variant="primary"
                          disabled={!isFormChanged}
                          onClick={handleSubmit}
                        >
                          Update
                        </TrackNowButton>
                      )}
                    </div>
                  </Stack>

                  {/* <Button
                  variant='contained'
                  style={{
                    color: "white",
                    width: "100px",
                    height: "42px",
                    marginLeft: "20px",
                  }}
                  disabled={!isFormChanged}
                  onClick={handleSubmitCheck}
                >
                  Check
                </Button> */}
                    </React.Fragment>
                  )} {/* end tabValue !== 3 */}

                  {/* ── Weekly Digest Tab Content ─────────────────────────── */}
                  {tabValue === 3 && (
                    <React.Fragment>
                      <Stack direction="column" spacing={2.5}>
                        <Stack direction="row" spacing={3} alignItems="center">
                          {/* User Dropdown with Search & Constrained Pop-up Height */}
                          {(() => {
                            const filteredWdUsers = wdEligibleUsers.filter((u) => {
                              const search = wdUserSearch.toLowerCase().trim();
                              if (!search) return true;
                              return (
                                u.userName?.toLowerCase().includes(search) ||
                                u.loginId?.toLowerCase().includes(search)
                              );
                            });

                            return (
                              <TrackNowSelect
                                sx={{ width: 400 }}
                                name="WdUser"
                                label="User"
                                required
                                value={wdSelectedUserId}
                                onChange={handleWdUserChange}
                                displayEmpty
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 280,
                                    },
                                    sx: {
                                      maxHeight: 280,
                                    },
                                  },
                                  autoFocus: false,
                                  TransitionProps: {
                                    onEntered: () => {
                                      wdSearchInputRef.current?.focus();
                                    },
                                  },
                                }}
                                onClose={() => setWdUserSearch("")}
                                renderValue={(selected) => {
                                  if (!selected) {
                                    return (
                                      <span style={{ color: tokens.colors.grey }}>
                                        Select user
                                      </span>
                                    );
                                  }
                                  const user = wdEligibleUsers.find(
                                    (u) => String(u.userId) === String(selected)
                                  );
                                  return user ? user.userName : "Select user";
                                }}
                              >
                                <ListSubheader
                                  sx={{
                                    backgroundColor: "#fff",
                                    pt: 1,
                                    pb: 1,
                                    px: 1.5,
                                    lineHeight: "normal",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  onKeyDown={(e) => {
                                    if (e.key !== "Escape") {
                                      e.stopPropagation();
                                    }
                                  }}
                                >
                                  <TextField
                                    size="small"
                                    autoFocus
                                    inputRef={wdSearchInputRef}
                                    placeholder="Search user..."
                                    fullWidth
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <GoogleMaterialIcon
                                            iconName="search"
                                            sx={{ fontSize: "20px", color: tokens.colors.grey }}
                                          />
                                        </InputAdornment>
                                      ),
                                      endAdornment: wdUserSearch ? (
                                        <InputAdornment position="end">
                                          <IconButton
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setWdUserSearch("");
                                              wdSearchInputRef.current?.focus();
                                            }}
                                            sx={{ padding: "2px" }}
                                          >
                                            <GoogleMaterialIcon
                                              iconName="close"
                                              sx={{ fontSize: "16px", color: tokens.colors.grey }}
                                            />
                                          </IconButton>
                                        </InputAdornment>
                                      ) : null,
                                    }}
                                    value={wdUserSearch}
                                    onChange={(e) => setWdUserSearch(e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => {
                                      if (e.key !== "Escape") {
                                        e.stopPropagation();
                                      }
                                    }}
                                  />
                                </ListSubheader>

                                <MenuItem value="">Select user</MenuItem>

                                {filteredWdUsers.length > 0 ? (
                                  filteredWdUsers.map((u) => (
                                    <MenuItem key={u.userId} value={u.userId}>
                                      {u.userName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled value="">
                                    No users found
                                  </MenuItem>
                                )}

                                {Boolean(
                                  wdSelectedUserId &&
                                    !filteredWdUsers.some(
                                      (u) => String(u.userId) === String(wdSelectedUserId)
                                    )
                                ) && (
                                  <MenuItem
                                    key={wdSelectedUserId}
                                    value={wdSelectedUserId}
                                    style={{ display: "none" }}
                                  >
                                    {wdEligibleUsers.find(
                                      (u) => String(u.userId) === String(wdSelectedUserId)
                                    )?.userName || ""}
                                  </MenuItem>
                                )}
                              </TrackNowSelect>
                            );
                          })()}

                          {/* Enable Digest Toggle */}
                          <TrackNowSwitchField
                            name="WdEnabled"
                            label="Enable Digest"
                            checked={Boolean(wdEnabled)}
                            onChange={handleWdToggleSwitch}
                          />
                        </Stack>

                        {/* Info Message banner for ClientAdmin */}
                        {(() => {
                          const currentWdUser =
                            wdEligibleUsers.find(
                              (u) => String(u.userId) === String(wdSelectedUserId)
                            ) ||
                            (wdEditingRowId
                              ? wdConfiguredList.find((r) => r.id === wdEditingRowId)
                              : null);
                          if (currentWdUser?.isClientAdmin && currentWdUser?.infoMessage) {
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  backgroundColor: "#e8f4fd",
                                  border: "1px solid #b6d4fe",
                                  color: "#0c5460",
                                  padding: "10px 14px",
                                  borderRadius: "8px",
                                  width: 400,
                                  boxSizing: "border-box",
                                  fontSize: "13px",
                                  fontFamily: "Area Normal, Inter, sans-serif",
                                  lineHeight: 1.4,
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    fontSize: "20px",
                                    color: "#0288d1",
                                    flexShrink: 0,
                                  }}
                                >
                                  info
                                </span>
                                <span>{currentWdUser.infoMessage}</span>
                              </Box>
                            );
                          }
                          return null;
                        })()}

                        {/* Email Address with inline Edit */}
                        <Stack direction="row" spacing={1} alignItems="flex-end">
                          <TrackNowTextField
                            sx={{ width: 400 }}
                            label="Email Address"
                            required
                            placeholder="Auto-populated from selected user"
                            value={wdEmailEditing ? wdEmailOverride : wdEmail}
                            onChange={
                              wdEmailEditing
                                ? (e) => setWdEmailOverride(e.target.value)
                                : undefined
                            }
                            InputProps={{ readOnly: !wdEmailEditing }}
                          />
                          <Tooltip title={wdEmailEditing ? "Confirm email" : "Edit email"}>
                            <span>
                              <GoogleIconButton
                                iconName={wdEmailEditing ? "check_circle" : "edit"}
                                iconColor={wdEmail ? primaryColor : tokens.colors.grey}
                                disabled={!wdEmail}
                                onClick={() => {
                                  if (wdEmailEditing) {
                                    setWdEmail(wdEmailOverride);
                                    setWdEmailEditing(false);
                                  } else {
                                    setWdEmailOverride(wdEmail);
                                    setWdEmailEditing(true);
                                  }
                                }}
                                sx={{
                                  "&:hover": { backgroundColor: `${primaryColor}1A` },
                                  "& .MuiTouchRipple-root .MuiTouchRipple-child": { backgroundColor: primaryColor },
                                }}
                              />
                            </span>
                          </Tooltip>
                        </Stack>

                        {/* Action buttons */}
                        <Stack direction="row" justifyContent="flex-end" spacing={1}>
                          <TrackNowButton variant="tertiary" onClick={handleWdReset}>
                            Reset
                          </TrackNowButton>
                          <TrackNowButton
                            variant="primary"
                            disabled={!wdSelectedUserId}
                            onClick={handleWdSave}
                          >
                            {wdEditingRowId ? "Update" : "Save"}
                          </TrackNowButton>
                        </Stack>
                      </Stack>
                    </React.Fragment>
                  )}

                </Stack>
              </Box>

              {/* Existing Reminder/PastDue/Completed DataTable */}
              {tabValue !== 3 && (
              <div
                className="card"
                style={{
                  padding: "0.5rem",
                  background: tokens.colors.offWhite,
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    padding: "1rem",
                    margin: "1rem",
                    background: tokens.colors.offWhite,
                    borderRadius: "8px",
                  }}
                >
                  <DataTableBase
                    data={configurationListNew}
                    tableHeaderColor={tableHeaderColor}
                    fixedHeader
                    fixedHeaderScrollHeight="55vh"
                    columns={[
                      {
                        name: 'Select',
                        width: '80px',
                        cell: row => (
                          <TrackNowCheckbox
                            checked={selectedEmail.some(email => email.emailTaskId === row.emailTaskId)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleSelect({ value: [...selectedEmail, row] });
                              } else {
                                handleSelect({ value: selectedEmail.filter(email => email.emailTaskId !== row.emailTaskId) });
                              }
                            }}
                          />
                        )
                      },
                      {
                        name: 'Client',
                        selector: row => row.customerId,
                        width: '200px',
                        cell: row => (
                          <div style={{ fontSize: '15px', padding: '4px 8px' }}>
                            {row.customerId && row.customerId.length > 9 ? (
                              <Tooltip title={getClientName(row.customerId)} arrow>
                                <span>{row.customerId.substring(0, 9)}...</span>
                              </Tooltip>
                            ) : (
                              getClientName(row.customerId)
                            )}
                          </div>
                        )
                      },
                      // ✅ CONDITIONAL COLUMNS
                      ...(tabValue === 0
                        ? [
                          {
                            name: 'Reminder Days Before',
                            selector: row => row.reminderStartInDays,
                            width: '180px',
                            cell: row => {
                              const removedNegative = row.reminderStartInDays < 0
                                ? Math.abs(row.reminderStartInDays)
                                : row.reminderStartInDays;
                              return (
                                <div style={{ fontSize: '15px', padding: '4px 8px' }}>
                                  {removedNegative}
                                </div>
                              );
                            }
                          },
                          {
                            name: 'Due Date Option',
                            selector: row => row.reminderBasedOnField,
                            width: '150px',
                            cell: row => {
                              const dueDateFormated =
                                row.reminderBasedOnField === "FilingDueDate" || row.reminderBasedOnField === "Filing"
                                  ? "Filing"
                                  : row.reminderBasedOnField === "DueDate" || row.reminderBasedOnField === "Internal"
                                    ? "Internal"
                                    : "Both";

                              return (
                                <div style={{ fontSize: '15px', padding: '4px 8px' }}>
                                  {dueDateFormated}
                                </div>
                              );
                            }
                          }
                        ]
                        : []),
                      {
                        name: 'Enable Notification',
                        selector: row => row.isActive,
                        width: '120px',
                        cell: row => (
                          <InputSwitch name="Notifications" checked={row.isActive} />
                        )
                      },
                      {
                        name: 'Record Type',
                        selector: row => row.recordType,
                        width: '120px',
                        cell: row => (
                          <div style={{ fontSize: '15px', padding: '4px 8px' }}>
                            {row.recordType}
                          </div>
                        )
                      },
                      {
                        name: 'Email Reminder Subject',
                        selector: row => row.emailSubject,
                        width: '250px',
                        cell: row => (
                          <div style={{ fontSize: '15px', padding: '4px 8px' }}>
                            {row.emailSubject}
                          </div>
                        )
                      },
                      {
                        name: 'Email Reminder Message',
                        selector: row => row.emailMessage,
                        width: '300px',
                        cell: row => {
                          const emailMessageWithoutLinks = row.emailMessage
                            .replace(/<a\b[^>]*>(.*?)<\/a>/g, "")
                            .replace(/Please click on this link to Login:/g, "")
                            .replace(/<hr\/?>/g, "")
                            .replace(/<br\/?>/g, "");
                          return (
                            <div
                              style={{ fontSize: '15px', padding: '4px 8px' }}
                              dangerouslySetInnerHTML={{ __html: emailMessageWithoutLinks }}
                            />
                          );
                        }
                      },
                      {
                        name: 'Actions',
                        width: '120px',
                        cell: row => (
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <GoogleIconButton
                              iconName={ICONS.edit}
                              iconColor={primaryColor}
                              disabled={isPermission}
                              onClick={() => editReminder(row)}
                              sx={{
                                '&:hover': { backgroundColor: `${primaryColor}1A` },
                                '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
                              }}
                            />
                            <GoogleIconButton
                              iconName={ICONS.delete}
                              iconColor={primaryColor}
                              disabled={isPermission}
                              onClick={() => handleDelete(row)}
                              sx={{
                                '&:hover': { backgroundColor: `${primaryColor}1A` },
                                '& .MuiTouchRipple-root .MuiTouchRipple-child': { backgroundColor: primaryColor },
                              }}
                            />
                          </div>
                        )
                      }
                    ]}
                    progressPending={isDataTableLoading}
                    noDataComponent="No reminders found"
                    subHeader
                    subHeaderComponent={
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        marginBottom: '1rem'
                      }}>
                        <Typography
                          variant="h6"
                          noWrap
                          component="div"
                          sx={{
                            fontWeight: 400,
                            color: "inherit",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          REMINDER CONFIGURATIONS ({configurationListNew.length})
                        </Typography>
                      </div>
                    }
                  />
                </div>
              </div>
              )} {/* end tabValue !== 3 DataTable */}

              {/* ── Weekly Digest Configured Users Table ──────────────────── */}
              {tabValue === 3 && (
                <div
                  className="card"
                  style={{
                    padding: "0.5rem",
                    background: tokens.colors.offWhite,
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      padding: "1rem",
                      margin: "1rem",
                      background: tokens.colors.offWhite,
                      borderRadius: "8px",
                    }}
                  >
                    <DataTableBase
                      data={wdConfiguredList}
                      tableHeaderColor={tableHeaderColor}
                      fixedHeader
                      fixedHeaderScrollHeight="55vh"
                      progressPending={isWdTableLoading}
                      noDataComponent="No digest users configured yet"
                      subHeader
                      subHeaderComponent={
                        <div style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                          marginBottom: "1rem",
                        }}>
                          <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{
                              fontWeight: 400,
                              color: "inherit",
                              textDecoration: "none",
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            WEEKLY FILING DIGEST CONFIGURATIONS ({wdConfiguredList.length})
                          </Typography>
                        </div>
                      }
                      columns={[
                        {
                          name: "User Name",
                          selector: (row) => row.userName,
                          grow: 1,
                          minWidth: "200px",
                          cell: (row) => (
                            <div style={{ fontSize: "15px", padding: "4px 8px", whiteSpace: "nowrap" }}>
                              {row.userName}
                            </div>
                          ),
                        },
                        {
                          name: "Email Address",
                          selector: (row) => row.emailId,
                          grow: 2,
                          minWidth: "300px",
                          cell: (row) => (
                            <div style={{ fontSize: "15px", padding: "4px 8px", whiteSpace: "nowrap" }}>
                              {row.emailId}
                            </div>
                          ),
                        },
                        {
                          name: "Status",
                          selector: (row) => row.isEnabled,
                          width: "120px",
                          cell: (row) => (
                            <InputSwitch
                              name="WdStatus"
                              checked={Boolean(row.isEnabled)}
                              onChange={() => handleWdToggleRow(row)}
                            />
                          ),
                        },
                        {
                          name: "Actions",
                          width: "120px",
                          cell: (row) => (
                            <div style={{ display: "flex", gap: "8px" }}>
                              <GoogleIconButton
                                iconName={ICONS.edit}
                                iconColor={primaryColor}
                                onClick={() => handleWdEditRow(row)}
                                sx={{
                                  "&:hover": { backgroundColor: `${primaryColor}1A` },
                                  "& .MuiTouchRipple-root .MuiTouchRipple-child": { backgroundColor: primaryColor },
                                }}
                              />
                              <GoogleIconButton
                                iconName={ICONS.delete}
                                iconColor={primaryColor}
                                onClick={() => handleWdDeleteRow(row)}
                                sx={{
                                  "&:hover": { backgroundColor: `${primaryColor}1A` },
                                  "& .MuiTouchRipple-root .MuiTouchRipple-child": { backgroundColor: primaryColor },
                                }}
                              />
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                </div>
              )}
            </Container>

          </Stack>

          <ConfirmDialog />
          <NotificationsDialog />
          <WdConfirmDialog />
          <CustomDialog
            header="Info"
            visible={showAlert}
            onHide={() => closeAlert()}
            footer={null}
          >
            <p className='m-0'>{alertMessage}</p>
          </CustomDialog>
        </Stack>
      )
      }
      {
        <ReminderHistory
          show={showHistory}
          dockAt="right"
          selectedEmail={selectedEmail}
          customerList={customerList}
          // commentActivityHistory={commentActivityHistory}
          activityHistory={activityHistory}
          handleClose={closeHistory}
        />
      }
    </React.Fragment >
  );
}

